export default {
  // the app loader on the first load (#223)
  app_loader: {
    title: 'Préparation de GreenMapper',
    steps: {
      connect: 'Connexion à GreenMapper',
      account: 'Récupération de ton compte',
      places: 'Les zones sur la carte',
      communities: 'Chargement des communautés',
      news: 'Actualités et réglages',
      settings: 'Tout se prépare',
      ready: 'Prêt !'
    },
    slow: 'Cela prend plus de temps que d’habitude.',
    retry: 'Réessayer',
    open_anyway: 'Ouvrir quand même'
  },
  // a login link from an e-mail and an unknown address (#340: on the app loader's card)
  redirect: {
    failed: 'Ce lien de connexion ne fonctionne plus',
    title: 'Connexion en cours…',
    step: 'Connexion'
  },
  not_found: {
    checking: 'Nous vérifions si la page existe…',
    checking_sub: 'Recherche de la page',
    title: '404 : page introuvable',
    text: 'Il n’y a rien à cette adresse.',
    home: 'Retour à l’accueil'
  },
  notice: {
    progress: '{done} lieux sur {total} marqués',
    places_left: 'Encore 1 lieu à marquer | Encore {left} lieux à marquer',
    participation_hint: 'Encore quelques étapes pour compléter vos lieux.',
    participation_unfinished: 'Votre participation n\'est pas encore terminée'
  },
  home_tiles: {
    areas_count: '{count} zone | {count} zones',
    communities_count: '{count} communauté | {count} communautés',
    budget_line: '{amount} budget · {pct}% promis',
    subscribers: '{count} abonné | {count} abonnés',
    notifications: 'Notifications',
    unread: '{count} non lu | {count} non lus',
    all_read: 'Tout est lu',
    no_messages: 'Aucun message',
    pledged: 'promis',
    no_budget: 'Pas encore de budget nature',
    no_areas: 'Aucune zone. Marquez sur la carte les lieux qui comptent pour vous.',
    no_communities: 'Vous ne suivez encore aucune communauté.',
    browse_map: 'Voir la carte',
    greet_morning: 'Bonjour, {name}',
    greet_afternoon: 'Bon après-midi, {name}',
    greet_evening: 'Bonsoir, {name}',
    per_year: 'par an',
    new: 'nouveau'
  },
  wizard_versions: {
    // #321: the find screen's list / map switch (phones) and the larger map (wider screens)
    search_short: 'Rechercher',
    view_list: 'Liste',
    view_map: 'Carte',
    map_larger: 'Agrandir la carte',
    map_smaller: 'Réafficher la liste',
    cancel: 'Annuler',
    question: 'Quelle zone gérez-vous ?',
    results: 'Résultats',
    legend: 'Filtres',
    filters_open: 'Ouvrir les filtres',
    filters_collapse: 'Replier les filtres',
    new_community: 'Nouvelle communauté',
    back_to_results: 'Retour à la liste',
    col_name: 'Nom',
    my_location: 'Ma position',
    locate: 'Zones près de ma position',
    locate_failed: 'Votre position n\'a pas pu être trouvée. Recherchez un lieu.',
    locate_denied: 'Vous n\'avez pas partagé votre position. Autorisez-la dans le navigateur, ou recherchez un lieu.',
    locate_insecure: 'Votre position ne fonctionne que via une connexion sécurisée (https). Recherchez un lieu.',
    loading_results: 'Chargement des zones…',
    lists_n: '{count} listes',
    col_type: 'Type',
    col_country: 'Pays',
    col_size: 'Superficie',
    position: 'Position',
    loading_title: 'Préparation de la carte',
    load_lists: 'Les listes',
    load_areas: 'Les premières zones',
    load_map: '{list} sur la carte',
    load_index: 'Construction de la carte',
    areas_here: '{count} zones ici',
    choose_area_here: 'Choisissez l\'une des {count} zones ici',
    map_updating: 'Mise à jour de la carte…',
    map_areas_loading: 'Chargement des zones…',
    map_loading: 'La carte charge encore toutes les zones…',
    sheet: 'Agrandir ou réduire la liste',
    count_areas: 'aucune zone | 1 zone | {count} zones',
    slow: 'Cela prend plus de temps que d\'habitude.',
    try_again: 'Réessayer',
    offline: 'Pas de connexion au serveur. Reconnexion…',
    reconnect: 'Réessayer maintenant',
    lists_failed: 'Les listes n\'ont pas pu être chargées.',
    places_failed: 'Les lieux n\'ont pas pu être recherchés.',
    sending: 'Envoi de votre communauté…',
    count_failed: 'Les fans n\'ont pas pu être comptés.'
  },
  messages: {
    pictures_missing: 'Une photo de cette discussion n’a pas pu être chargée : elle sera retirée à l’enregistrement.',
    account_created: 'Compte créé avec succès',
    password_forgot: 'Consultez votre e-mail pour réinitialiser votre mot de passe.',
    account_signed_out: 'Vous avez été déconnecté',
    logout_failed: 'La déconnexion a échoué. Veuillez réessayer.',
    account_updated: 'Compte mis à jour avec succès',
    verification_success: 'Votre adresse e-mail a été vérifiée. Vous pouvez maintenant vous connecter.',
    verification_failed: 'La vérification a échoué.',
    password_recover_success: 'Votre mot de passe a été réinitialisé. Vous pouvez maintenant vous connecter avec le nouveau mot de passe.',
    password_reset_link_invalid: 'Ce lien ne fonctionne plus. Un lien de réinitialisation fonctionne une seule fois, pendant 24 heures. Demandez-en un nouveau avec « Mot de passe oublié ? » sur l\'écran de connexion.',
    password_reset_failed: 'Votre mot de passe n\'a pas pu être modifié. Veuillez réessayer.',
    password_reset_to_login: 'Vers l\'écran de connexion',
    logout_confirmation: 'Voulez-vous vraiment vous déconnecter ?',
    login_confirmation: 'Vous êtes connecté. Bon retour parmi nous !',
    login_failed: 'Combinaison e-mail et mot de passe non reconnue',
    confirm: 'Confirmer',
    update_available: 'Une nouvelle mise à jour est disponible. Cliquez sur ok pour recharger la page.',
    update_ready: 'Une nouvelle version de l\'application est prête.',
    update_reload: 'Recharger',
    url_copied_to_clipboard: 'L\'URL de la carte a été copiée dans le presse-papiers',
    add_area_account_required: 'Pour ajouter une nouvelle zone, vous devez avoir un compte.',
    area_deleted: 'La zone a été supprimée',
    area_updated: 'La zone a été mise à jour',
    unsubscribed: 'Vous vous êtes désabonné de la communauté',
    subscribed: 'Vous faites maintenant partie de cette communauté',
    thread_created: 'Une nouvelle discussion a été créée',
    thread_updated: 'La discussion a été mise à jour',
    comment_created: 'Vous avez publié une réponse',
    comment_reported: 'Ce contenu a été signalé pour modération',
    comment_unreported: 'Ce contenu a été validé par la modération',
    comment_deleted: 'Ce contenu a été supprimé',
    community_updated: 'Cette communauté a été mise à jour',
    RMS_send: 'La demande de modérateur a été envoyée',
    poll_created: 'Sondage créé',
    polis_created: 'Polis créé',
    meeting_created: 'Réunion créée',
    meeting_invite_accepted: 'Vous avez accepté l\'invitation',
    meeting_invite_declined: 'Vous avez décliné l\'invitation',
    pledge_funding_completed: 'Financement virtuel par promesse de don effectué avec succès',
    pledge_added: 'Merci pour votre promesse de don de € ',
    pledge_rejected: 'Merci pour votre explication',
    pledge_created: 'Promesse de don créée',
    pledge_updated: 'Promesse de don mise à jour',
    pledge_deleted: 'La promesse de don a été supprimée',
    pledge_pictures_missing: 'Une photo de cette promesse n\'a pas pu être chargée : elle sera omise à l\'enregistrement.',
    treasure_created: 'Trésor ajouté'
  },
  errors: {
    general_error: 'Une erreur s\'est produite. Veuillez réessayer.',
    not_found: 'Désolé, il n\'y a rien ici...',
    network: 'Erreur réseau. Vérifiez votre connexion internet',
    required: 'Champ obligatoire',
    register: {
      password_length: 'Le mot de passe doit contenir au moins {length} caractères.',
      password_match: 'Les mots de passe ne correspondent pas.',
      email_valid: 'Une adresse e-mail valide est requise',
      name_length: 'Le nom d\'affichage doit contenir entre {minLength} et {maxLength} caractères',
      organization_length: 'Le nom de l\'organisation doit contenir entre {minLength} et {maxLength} caractères'
    }
  },
  buttons: {
    fullscreen: 'Plein écran',
    fullscreen_exit: 'Quitter le plein écran',
    pledge: 'Promettre un don',
    ok: 'Ok',
    submit: 'Envoyer',
    logout: 'Se déconnecter',
    cancel: 'Annuler',
    login: 'Se connecter',
    register: 'Envoyer',
    send: 'Envoyer',
    reSend: 'Renvoyer',
    close: 'Fermer',
    previous: 'Précédent',
    save: 'Enregistrer',
    create: 'Créer',
    update: 'Mettre à jour',
    delete: 'Supprimer',
    subscribe: 'S\'abonner',
    unsubscribe: 'Se désabonner',
    next: 'Suivant',
    continue: 'Continuer',
    back: 'Retour',
    add: 'Ajouter',
    edit: 'Modifier',
    reply: 'Répondre',
    report: 'Signaler',
    unreport: 'Annuler le signalement',
    goto_authenticate: 'Vers la connexion',
    stop: 'Arrêter',
    pauze: 'Pause',
    continue_register: 'Continuer l\'inscription',
    continue_participation: 'Continuer la participation',
    mark_places: 'Marquer des lieux',
    become_moderator: 'Devenir modérateur',
    add_image: 'Ajouter une image',
    accept: 'Accepter',
    decline: 'Décliner',
    reset: 'Réinitialiser',
    discard: 'Abandonner'
  },
  headers: {
    area_owners: 'Propriétaires de terrain',
    admin_home: 'Accueil',
    fans: 'Fans',
    maintenance: 'Maintenance',
    login: 'Connexion',
    register: 'Inscription',
    password_forgot: 'Demander un nouveau mot de passe',
    password_recover: 'Réinitialiser le mot de passe',
    administrator: 'Administrateur',
    navigation: 'Navigation',
    my_overview: 'Mon aperçu',
    overview: 'Aperçu',
    users: 'Utilisateurs',
    communities: 'Communautés'
  },
  activities: {
    act_cycl: {
      title: 'Vélo'
    },
    act_walk: {
      title: 'Marche ou course'
    },
    act_tour: {
      title: 'Balade en voiture ou à moto'
    },
    act_natu: {
      title: 'Observer la nature'
    },
    act_water: {
      title: 'Sports nautiques'
    },
    act_play: {
      title: 'Jouer ou se détendre'
    },
    act_wintr: {
      title: 'Sports d\'hiver'
    },
    act_mount: {
      title: 'Sports de montagne'
    }
  },
  labels: {
    upvote: 'Pour',
    // a post's reply started from a comment (#340): the bar above the reply
    replying_to: 'Réponse à',
    replying_to_cancel: 'Pas en réponse à {name}',
    // the photo picker (UiPhotoPicker, #469)
    photo_add: 'Ajouter une photo',
    photos_add: 'Ajouter des photos',
    photos_add_short: 'Ajouter',
    photos_drop: 'touchez, ou déposez-les ici (.jpg)',
    photos_jpg_only: 'Seules les photos .jpg peuvent être ajoutées.',
    downvote: 'Contre',
    // a wizard's step (UiWizard, #355)
    step_of: 'Étape {step} sur {total}',
    rows_of: '{shown} sur {total}',
    show_more: 'Afficher {n} de plus',
    account_required: 'Compte requis',
    read_more: 'lire la suite',
    area_create_button: 'Enregistrer',
    area_update_button: 'Enregistrer',
    area_created_succes: 'La zone a été créée avec succès',
    area_updated_succes: 'La zone a été mise à jour avec succès',
    community_created_succes: 'La communauté a été créée avec succès',
    agree_disclaimer: 'J\'accepte ces conditions',
    my_account: 'Mon compte',
    register: 'Créer un compte',
    logout: 'Se déconnecter',
    login: 'Se connecter',
    email: 'Adresse e-mail',
    name: 'Nom d\'affichage',
    companyName: 'Nom de l\'entreprise',
    organization: 'Nom de l\'organisation',
    sector: 'Secteur',
    address: 'Adresse',
    address_search: 'Adresse',
    website: 'Site web',
    city: 'Ville',
    age: 'Tranche d\'âge',
    education: 'Formation',
    gender: 'Genre',
    type: 'Type',
    password: 'Mot de passe',
    repeat_password: 'Répétez le mot de passe',
    remember_me: 'Se souvenir de moi',
    show_password: 'Afficher le mot de passe',
    hide_password: 'Masquer le mot de passe',
    clear_address: 'Choisir une autre adresse',
    password_forgot: 'Mot de passe oublié ?',
    home: 'Accueil',
    here: 'ici',
    neighbourhood: 'quartier',
    'living-area': 'région',
    country: 'pays',
    worldwide: 'monde',
    share_this_area: 'Partager cette zone',
    share_this_community: 'Partager cette communauté',
    subscribed: 'Abonné',
    reply: 'Répondre',
    comment: 'Commentaire',
    finish: 'Terminer',
    readmore: 'lire la suite',
    search: 'rechercher',
    created_on: 'créé le',
    dear: 'Cher/Chère',
    karma: 'Karma'
  },
  pages: {
    free_draw: {
      title: 'Dessinez votre zone',
      tools: 'Outils de dessin',
      mode_edit: 'Modifier les points',
      mode_move: 'Déplacer la forme',
      mode_rotate: 'Faire pivoter la forme',
      undo: 'Annuler',
      more_tools: 'Plus d’outils',
      redo: 'Rétablir',
      delete_points: 'Supprimer des points',
      import: 'Importer un fichier (GeoJSON ou KML)',
      start_over: 'Recommencer',
      start_over_title: 'Recommencer ?',
      start_over_text: 'Cela supprime la forme. Vous pouvez encore annuler.',
      layer_map: 'Carte',
      layer_satellite: 'Satellite',
      my_location: 'Ma position',
      zoom_to_shape: 'Zoomer sur la forme',
      search_place: 'Rechercher un lieu',
      search_place_placeholder: 'Lieu, puis Entrée',
      warn_point_outside: 'Votre dessin ne contient pas l’emplacement de {name}.',
      warn_size: 'Votre dessin ({drawn}) s’écarte beaucoup de la superficie déclarée ({reported}).',
      warn_huge: 'Votre zone est très grande : {size}. Est-ce correct ?',
      more: 'Plus',
      hint_closed_phone: 'Forme fermée. Faites glisser un point pour ajuster la limite ; maintenez un point appuyé pour le supprimer.',
      hint_many_phone: 'Forme de {count} points : ils sont affichés espacés. Zoomez pour plus de points à faire glisser.',
      legend_title: 'Également utile',
      legend_last: 'Cliquez sur le dernier point pour le supprimer',
      legend_undo: 'Ctrl+Z annule, Ctrl+Y rétablit',
      legend_import: 'Vous pouvez aussi importer une limite (GeoJSON ou KML)',
      reported: 'Déclarée : {size}',
      your_drawing: 'votre dessin : {size}',
      area: 'Surface',
      border: 'Limite',
      close_shape: 'Fermer la forme',
      close_shape_tip: 'Ou cliquez sur le premier point, ou appuyez sur Échap',
      points_count: 'aucun point | 1 point | {count} points',
      hint_tap: 'Cliquez sur la carte pour placer des points le long de la limite. Cliquez sur le premier point pour fermer la forme.',
      hint_edit: 'Faites glisser un point pour le déplacer. Faites glisser un petit point sur une ligne pour ajouter un point. Clic droit sur un point pour le supprimer.',
      hint_edit_many: 'Cette forme a beaucoup de points : ils sont affichés espacés, davantage à mesure que vous zoomez. Faites glisser un point pour le déplacer. Faites glisser un petit point sur une ligne pour ajouter un point. Clic droit sur un point pour le supprimer.',
      hint_delete: 'Touchez un point pour le supprimer. Touchez de nouveau l’outil de suppression pour arrêter.',
      hint_delete_click: 'Cliquez sur un point pour le supprimer. Cliquez de nouveau sur l’outil de suppression pour arrêter.',
      hint_move: 'Faites glisser la forme pour la déplacer.',
      hint_rotate: 'Faites glisser une poignée d’angle pour faire pivoter la forme.',
      check_points: 'Forme fermée d’au moins {min} points',
      check_crossing: 'Aucune ligne qui se croise',
      check_range: 'Pas à cheval sur la ligne de changement de date (180°)',
      check_area_min: 'Au moins {minArea}',
      check_area_max: 'Au plus {maxArea}',
      check_points_max: 'Au plus {max} points',
      problem_points: 'Fermez la forme avec au moins {min} points.',
      problem_crossing: 'Des lignes se croisent. Déplacez un point pour qu’elles ne se croisent plus.',
      problem_range: 'La forme traverse la ligne de changement de date (180°). Dessinez-la d’un seul côté de cette ligne.',
      problem_area_min: 'La zone est trop petite : au moins {minArea}.',
      problem_area_max: 'La zone est trop grande : au plus {maxArea}.',
      problem_points_max: 'La forme a trop de points : au plus {max}.',
      rejected_cross: 'Les lignes ne doivent pas se croiser',
      rejected_min_points: 'Au moins {min} points',
      location_unavailable: 'Votre position n’est pas disponible.',
      imported: 'Forme de {count} points importée. Vérifiez-la et ajustez-la si nécessaire.',
      import_errors: {
        unknown_format: 'Ce fichier n’est ni du GeoJSON ni du KML.',
        no_polygon: 'Le fichier ne contient aucune zone (polygone).',
        multiple: 'Le fichier contient plusieurs zones. Utilisez un fichier avec une seule zone.',
        holes: 'La zone comporte des trous. Utilisez une zone sans trous.',
        invalid: 'La zone de ce fichier n’est pas valide.'
      }
    },
    owner_community_new: {
      // #197: the boundary lies on (almost) the same area as an existing community
      overlap: {
        warning: 'Il existe déjà une communauté sur (presque) la même zone : {title}. Vous pouvez quand même en créer une.',
        // another owner's community before its first approval: its name is not shown (#96)
        unnamed: 'une communauté en attente de validation'
      },
      // #198: after drawing, the list area the drawing matches
      suggest: {
        title_used: 'Votre zone',
        locked_size: 'Limite officielle · {size}',
        locked_hint: 'Vous utilisez la limite officielle. Dessiner vous-même ? Choisissez Annuler.',
        checking: 'Vérification…',
        choose_first: 'Choisissez d’abord : la limite officielle ou votre propre dessin',
        question: 'Est-ce la zone que vous voulez dire ?',
        previous: 'Précédent',
        next: 'Suivant',
        count: '{at} sur {of}',
        use_official: 'Utiliser la limite officielle',
        link: 'Lier mon dessin',
        keep: 'Garder mon dessin',
        link_note: 'Cette zone n’a pas de limite dans la liste : votre dessin devient sa limite, le nom et les détails viennent de la liste. Les autres propriétaires ne pourront plus la choisir.',
        used: 'Limite officielle de {name} utilisée',
        linked: 'Votre dessin est lié à {name}',
        kept: 'Vous gardez votre propre dessin',
        undo: 'Annuler',
        show_again: 'Revoir'
      },
      title_draw: 'Dessinez votre zone',
      title_draw_boundary: 'Dessinez la limite',
      title_details: 'Nommez votre communauté',
      title_fans: 'Qui compte comme fan',
      title_fans_named: 'Qui devient fan de {name} ?',
      drawn_tag: 'Dessiné vous-même',
      continue_short: 'Continuer',
      continue: 'Continuer vers le nom et la description',
      continue_fans: 'Continuer vers qui compte comme fan',
      name: 'Nom de la communauté',
      name_required: 'Donnez un nom à votre communauté.',
      description: 'Description',
      description_hint: 'Quelle est cette zone et de quoi parle la communauté ?',
      description_required: 'Décrivez la zone et la communauté.',
      submitted: '{name} est soumise pour vérification',
      review: {
        fans_count: '{n} fan | {n} fans',
        fans_few: 'moins de {n} fans',
        more: 'plus',
        submit: 'Soumettre pour vérification',
        confirm_title: 'Soumettre votre communauté ?',
        confirm_text: 'Greenmapper vérifie d’abord {name}. Après approbation, votre communauté aura {fans}. Vous pourrez encore modifier son nom et sa description.',
        confirm_plain: 'Greenmapper vérifie d’abord votre communauté. Vous pourrez encore modifier son nom et sa description.',
        confirm_back: 'Regarder encore',
        confirm_submit: 'Soumettre'
      },
      steps: {
        area: 'Zone',
        fans: 'Fans',
        name: 'Nom'
      },
      exit: 'Arrêter',
      exit_title: 'Arrêter la création de cette communauté ?',
      exit_text: 'Ce que vous avez choisi, dessiné ou saisi n’est pas enregistré.',
      exit_keep: 'Continuer',
      exit_confirm: 'Arrêter',
      back: 'Retour',
      method: {
        free_title: 'La dessiner vous-même',
        free_text: 'Dessinez la limite de votre zone sur la carte, ou importez un fichier GeoJSON ou KML.'
      },
      find: {
        clear_filters: 'Effacer les filtres',
        without_list: 'Sans {list}',
        with_list: 'Avec {list}',
        filters: 'Filtres',
        clear_all: 'Tout effacer',
        close: 'Fermer',
        lists_title: 'Listes',
        size: 'Superficie',
        size_any: 'Toute superficie',
        size_up_to: 'Jusqu\'à {max} ha',
        size_from: 'À partir de {min} ha',
        size_between: '{min}–{max} ha',
        place_title: 'Lieu',
        clear_place: 'Retirer le lieu',
        place_remove: 'Supprimer',
        countries_all: 'Afficher les {count} pays',
        countries_less: 'Moins de pays',
        show_n: 'Afficher 1 zone | Afficher {count} zones',
        places_none_in: 'Aucun lieu « {query} » en {country}',
        around_chip: 'Autour de {place}',
        none_near_named: 'Aucune zone avec « {query} » près de {place}.',
        radius: 'Rayon',
        radius_caption: 'Dans un rayon de',
        other_places: 'Autres lieux de ce nom',
        near_action: 'Zones à proximité',
        show_all: 'Afficher la zone avec « {query} » | Afficher les {count} zones avec « {query} »',
        country_search: 'Chercher un pays',
        country_any: 'Tous les pays',
        country_none: 'Aucun pays trouvé',
        none_named: 'Aucune zone nommée « {query} »',
        show_all_more: 'Afficher toutes les zones avec « {query} » ({count}+)',
        places_none: 'Aucun lieu trouvé',
        places_searching: 'Recherche de lieux…',
        places_failed: 'La recherche de lieux ne fonctionne pas pour le moment',
        availability: 'Disponibilité',
        count_more_short: '{count}+',
        refine: 'Affinez votre recherche pour voir le reste.',
        near_title: 'Zones autour de {place} (à {km} km)',
        places_group: 'Lieux',
        areas_group: 'Zones',
        place_kinds: {
          city: 'Ville',
          town: 'Ville',
          village: 'Village',
          hamlet: 'Hameau',
          suburb: 'Quartier',
          municipality: 'Commune',
          county: 'Département',
          state: 'Région',
          country: 'Pays',
          island: 'Île',
          nature_reserve: 'Réserve naturelle',
          national_park: 'Parc national',
          protected_area: 'Aire protégée',
          lake: 'Lac',
          peak: 'Sommet',
          forest: 'Forêt',
          wood: 'Bois',
          heath: 'Lande',
          moor: 'Tourbière',
          wetland: 'Zone humide'
        },
        title: 'Trouvez votre zone',
        search: 'Chercher une zone ou un lieu',
        country: 'Pays',
        all: 'Toutes',
        available: 'Libres',
        taken: 'Prises',
        count: 'aucune zone | 1 zone | {count} zones',
        failed: 'La recherche a échoué.',
        place_failed: 'La recherche de lieux ne répond pas pour le moment. La recherche par nom fonctionne toujours.',
        no_places: 'Aucun lieu trouvé pour « {query} ».',
        none_near: 'Aucune zone listée près de {place}.',
        none_filters: 'Aucune zone ne correspond à ces filtres.',
        none_taken: 'Aucune zone utilisée.',
        badge_official: 'Officielle',
        badge_partial: 'Zone centrale',
        badge_proxy: 'Approximative',
        badge_draw: 'À dessiner',
        also_in: 'Aussi dans {lists}',
        badge_in_use: 'Utilisée',
        badge_disabled: 'Indisponible',
        sources_short: {
          unesco: 'UNESCO',
          eea: 'AEE',
          wdpa: 'WDPA',
          osm: 'OSM',
          research: 'Recherche',
          national: 'National',
          arcgis: 'Couche',
          province: 'Province',
          other: 'Autre source'
        },
        osm_credit: '© contributeurs OpenStreetMap'
      },
      fans: {
        what: 'Toute personne ayant marqué sur Greenmapper un lieu dans votre zone de fans devient fan et reçoit vos messages.',
        what_close: 'Fermer l’explication',
        what_open: 'Qu’est-ce qu’un fan ?',
        slider: 'Taille de la zone de fans',
        area_only: 'Seulement votre zone',
        area_only_short: 'Zone seule',
        recommended: 'Recommandé',
        wide: 'Large',
        back_to_recommended: 'Revenir à recommandé',
        fans_short: 'fans dans la zone',
        legend_area: 'Votre zone',
        legend_zone: 'Zone de fans',
        legend_area_explain: 'Affichée comme communauté',
        legend_zone_explain: 'Détermine qui devient fan',
        legend_start: 'Recommandé',
        zone_is_area: 'identique à votre zone',
        load_failed: 'La zone de fans n’a pas pu être chargée.',
        retry: 'Réessayer',
        failed: 'Cette position n’a pas pu être calculée. Choisissez une autre position.',
        invalid: 'La zone de fans n’a pas été acceptée. Choisissez une autre position et réessayez.'
      },
      official: {
        not_listed_title: 'Votre zone n’est pas dans la liste ?',
        not_listed_text: 'Dessinez alors sa limite vous-même sur la carte.',
        choose_this: 'Choisir cette zone',
        title: 'Votre zone',
        retry: 'Réessayer',
        no_results: 'Aucune zone trouvée pour « {query} ».',
        badge_official: 'Limite officielle',
        badge_partial: 'Zone centrale seulement',
        badge_proxy: 'Zone approximative',
        badge_draw: 'Pas de limite : vous la dessinez',
        reason_in_use: 'Déjà utilisée',
        in_use_by: 'Déjà utilisée par {title}',
        reason_disabled: 'Non disponible',
        boundary_from: 'Limite : {source}.',
        boundary_drawn: 'Limite dessinée par vous',
        source_link_short: 'Ouvrir la page',
        fact_type: 'Type',
        fact_country: 'Pays',
        fact_size: 'Taille',
        fact_source: 'Source',
        boundary_title: 'Limite',
        boundary_free_same: 'Le même lieu figure encore une fois dans {list} ; cette limite est encore libre.',
        boundary_not_changed: 'La limite n\'a pas été modifiée : cela a pris trop de temps.',
        boundary_free_elsewhere: 'Le même lieu figure aussi dans {list} ; cette limite est encore libre.',
        choose_that: 'Choisir cette limite',
        boundary_list_in_use: '{list} : déjà utilisée par {title}',
        boundary_list_unavailable: '{list} : non disponible',
        partial_note: 'Cette limite ne couvre que la zone centrale de {name}, pas toute la zone.',
        proxy_note: 'Voici la zone qui a donné son nom à {name} ; la limite exacte n’est pas encore disponible.',
        draw_note: 'La liste n’a pas de limite pour {name}. Vous la dessinez ; la communauté garde le nom et les données de la liste.',
        draw_boundary: 'Dessiner la limite',
        reported_size: 'déclarée {size}',
        pick_hint: 'Choisissez une zone dans les résultats pour la voir sur la carte.',
        map: 'Carte',
        satellite: 'Satellite',
        reset_view: 'Afficher toute la zone',
        name_hint: 'Repris de la liste ; vous pouvez le modifier.',
        free_instead: 'La dessiner moi-même',
        in_use_error: '{name} vient d’être choisie pour une autre communauté. Les résultats sont mis à jour.',
        sources: {
          unesco: 'UNESCO',
          eea: 'Agence européenne pour l’environnement (AEE)',
          wdpa: 'Protected Planet (WDPA)',
          osm: 'OpenStreetMap',
          research: 'Jeu de données de recherche',
          national: 'Données ouvertes nationales',
          arcgis: 'Couche cartographique publiée',
          province: 'Carte de gestion de la nature de la province',
          other: 'Autre source'
        }
      }
    },
    owner_register: {
      title: 'Inscrivez votre organisation comme propriétaire de terrain',
      lead: 'Vous pouvez lancer une communauté autour d’un terrain que vous gérez. Avant cela, nous vérifions qui vous êtes.',
      what_happens: 'Ce qui se passe après l’inscription',
      step1_title: 'Créez votre compte',
      step1_text: 'Vous avez tout de suite votre page propriétaire.',
      step2_title: 'Nous vérifions votre organisation',
      step2_text: 'Un administrateur Greenmapper contrôle vos informations. Votre page propriétaire affiche le résultat.',
      step3_title: 'Créez vos communautés',
      step3_text: 'Choisissez une zone officielle ou dessinez la vôtre.',
      banner: 'Après l’inscription, un administrateur Greenmapper vérifie votre organisation. En attendant, vous voyez votre page propriétaire mais ne pouvez pas créer de communautés.',
      stepper_account: 'Votre compte',
      stepper_organization: 'Votre organisation',
      your_name: 'Votre nom',
      organization: 'Organisation',
      organization_too_long: '{maxLength} caractères maximum',
      organization_required: 'Indiquez le nom de votre organisation',
      consent: 'J’accepte la {link}.',
      privacy_statement: 'déclaration de confidentialité pour les organisations paysagères',
      consent_required: 'Acceptez la déclaration de confidentialité pour continuer.',
      submit: 'Créer le compte propriétaire',
      already_registered: 'Déjà inscrit ?',
      log_in: 'Se connecter',
      created: 'Votre compte propriétaire est prêt.'
    },
    owner_dashboard: {
      create_community: 'Créer une communauté',
      strip_pending: 'En attente de vérification.',
      strip_rejected: 'Votre inscription n’a pas été approuvée.',
      strip_verified: 'Vérifié',
      text_pending: 'Vous pouvez voir vos communautés. La modification et la création s’ouvrent dès qu’un administrateur Greenmapper a vérifié votre organisation.',
      text_rejected: 'Vous pouvez toujours vous connecter et voir vos communautés. Les modifications restent fermées.',
      text_verified: 'Vous pouvez créer et gérer vos communautés.',
      title_pending: 'Votre organisation est en cours de vérification',
      title_rejected: 'Votre inscription n’a pas été approuvée',
      lead_pending: 'Un administrateur Greenmapper vérifie {organization}. En attendant, vos communautés restent en ligne pour les fans et vous pouvez les voir ici.',
      lead_rejected: 'Un administrateur Greenmapper n’a pas pu vérifier {organization}. Vos communautés restent en ligne pour les fans et vous pouvez les voir ici.',
      feedback_label: 'Message de Greenmapper',
      got_it: 'Compris',
      new_badge: 'Nouveau',
      step_registered: 'Inscrit',
      step_registered_text: 'Votre compte propriétaire existe.',
      step_verification_pending: 'Vérification, en cours',
      step_verification_pending_text: 'Aucune action de votre part.',
      step_verification_rejected: 'Vérification, non approuvée',
      step_verification_rejected_text: 'Voir le message ci-dessus.',
      step_manage: 'Gérer les communautés',
      step_manage_text: 'Créer et modifier des communautés.',
      your_communities: 'Mes communautés',
      official_area: 'Zone officielle',
      drawn_area: 'Zone dessinée',
      boundary_drawn: 'limite dessinée par vous',
      fans: 'aucun fan | 1 fan | {count} fans',
      summary_communities: 'aucune communauté | 1 communauté | {count} communautés',
      community_verified: 'vérifiée par Greenmapper',
      community_status_pending: 'En attente de vérification',
      community_fans_after_approval: 'Les fans sont ajoutés dès que la communauté est approuvée.',
      community_status_verified: 'Vérifiée',
      community_status_rejected: 'Refusée',
      edit: 'Modifier',
      edit_community: 'Modifier {title}',
      community_status_changed: 'Modifiée · en attente de vérification',
      community_rejected_reason: 'Motif : {comment}',
      community_deleted: 'Votre communauté « {title} » a été supprimée par Greenmapper.',
      view_only: 'Lecture seule',
      no_communities_verified: 'Vous n’avez pas encore de communauté. Créez la première.',
      no_communities_waiting: 'Vous n’avez pas encore de communauté. Vous pourrez en créer une fois vérifié.'
    },
    community_edit: {
      title: 'Modifier la communauté',
      back: 'Retour',
      draw_title: 'Modifier la limite',
      change_boundary: 'Modifier la limite',
      official_read_only: 'Limite officielle : elle ne peut pas être modifiée.',
      boundary_not_editable: 'Cette limite ne peut pas être modifiée ici.',
      boundary_changed: 'Nouvelle limite, pas encore enregistrée',
      rereview_hint: 'Après l’enregistrement, Greenmapper vérifie à nouveau la nouvelle limite.',
      zone_removed: 'Une nouvelle limite supprime la zone de fans : les fans comptent alors à l’intérieur de la limite.',
      use_boundary: 'Utiliser cette limite',
      save: 'Enregistrer',
      saved: 'Modifications enregistrées',
      not_found: 'Communauté introuvable.',
      leave_title: 'Abandonner les modifications ?',
      leave_text: 'Vos modifications ne sont pas encore enregistrées.',
      leave_draw_text: 'Vos modifications de la limite seront perdues. La limite reste telle quelle.',
      leave_keep: 'Continuer',
      leave_confirm: 'Abandonner'
    },
    admin_home: {
      title: 'Admin',
      text: 'En construction : ici viendra la page d’accueil des admins.'
    },
    // the admin's e-mail templates and score settings (#341)
    email_templates: {
      title: 'Modèles d’e-mail',
      empty: 'Aucun modèle d’e-mail trouvé',
      col_key: 'Clé',
      col_description: 'Description'
    },
    score_settings: {
      title: 'Réglages des scores',
      empty: 'Aucun réglage de score trouvé',
      col_key: 'Clé',
      col_description: 'Description',
      col_value: 'Score'
    },
    admin_fans: {
      title: 'Fans',
      search: 'Nom, e-mail, tag ou lieu',
      stat_day: 'Nouveaux aujourd’hui',
      stat_week: 'Nouveaux en 7 jours',
      stat_month: 'Nouveaux en un mois',
      stat_year: 'Nouveaux en un an',
      stat_total: 'Tous les fans',
      col_name: 'Nom',
      col_email: 'E-mail',
      col_created: 'Inscrit',
      col_age: 'Âge',
      col_gender: 'Genre',
      col_score: 'Score',
      col_locale: 'Langue',
      col_areas: 'Zones',
      col_funding: 'Financement',
      col_tags: 'Tags',
      col_subs: 'Suit',
      funding_finished: 'Financement terminé',
      funding_not_finished: 'Financement non terminé',
      empty: 'Aucun fan trouvé.',
      areas_title: 'Zones',
      no_areas: 'Aucune zone dessinée.',
      profile_title: 'Profil',
      log_title: 'Journal d’activité',
      log_show: 'Afficher',
      log_hide: 'Masquer',
      log_filter: 'Filtrer le journal',
      log_empty: 'Aucune entrée.',
      log_none_match: 'Aucune entrée ne correspond au filtre.',
      log_failed: 'Impossible de charger le journal',
      log_session: 'Session',
      log_geometry: 'Géométrie',
      log_scope: 'Échelle',
      registration_finished: 'Inscription terminée',
      details: {
        user_id: 'ID utilisateur',
        created: 'Créé',
        email_verified: 'E-mail vérifié',
        place: 'Lieu',
        disclaimer: 'Avertissement accepté',
        updated: 'Profil modifié',
        education: 'Formation',
        city: 'Ville',
        communities: 'Communautés',
        no_communities: 'Ne suit aucune communauté',
        gone_communities: '{count} n’existe plus | {count} n’existent plus',
        funding: 'Promesse de financement',
        amount: 'Montant',
        reason: 'Raison',
        yes: 'oui',
        no: 'non'
      }
    },
    // the admin's communities screen (#341)
    admin_communities: {
      // the row menu's link to the community's area facts (#533)
      area_facts: 'Faits sur la zone',
      title: 'Communautés',
      search: 'Nom, propriétaire ou zone',
      col_name: 'Communauté',
      col_owner: 'Propriétaire',
      col_area: 'Zone',
      col_created: 'Créée',
      col_status: 'Statut',
      col_fanzone: 'Zone des fans',
      col_fans: 'Fans',
      col_threads: 'Discussions',
      col_polls: 'Sondages',
      col_polis: 'Polis',
      col_meetings: 'Réunions',
      col_pledges: 'Promesses',
      col_mods: 'Modérateurs',
      empty_waiting: 'Aucune communauté n\'attend de vérification.',
      empty_rejected: 'Aucune communauté refusée.',
      empty_verified: 'Pas encore de communauté vérifiée.',
      empty_all: 'Aucune communauté trouvée.',
      more_actions: 'Plus d\'actions pour {title}',
      open: 'Ouvrir la communauté',
      edit: 'Modifier',
      pending_done: '{title} attend de nouveau',
      reject_title: 'Refuser {title} ?',
      facts_title: 'Communauté',
      description_title: 'Description',
      no_description: 'Pas de description.',
      no_moderators: 'aucun',
      content: 'Contenu',
      fan_zone_fans: 'Fans dans la zone',
      fan_zone_after_approval: 'ajoutés à l\'approbation',
      fan_zone_size: 'Zone des fans',
      fan_zone_position: 'Position',
      fan_zone_start: 'Recommandée',
      fan_zone_area: 'Zone'
    },
    admin_owners: {
      title: 'Propriétaires de terrain',
      search: 'Nom, e-mail ou organisation',
      tab_waiting: 'En attente',
      tab_rejected: 'Refusés',
      tab_verified: 'Vérifiés',
      tab_all: 'Tous',
      only_with_communities: 'Seulement les propriétaires avec communautés',
      only_migrated: 'En attente depuis la migration ({count})',
      load_failed: 'Impossible de charger les propriétaires',
      empty_waiting: 'Personne n’attend de vérification.',
      empty_rejected: 'Aucun propriétaire refusé.',
      empty_verified: 'Aucun propriétaire vérifié pour l’instant.',
      empty_all: 'Aucun propriétaire trouvé.',
      status_pending: 'En attente',
      status_rejected: 'Refusé',
      status_verified: 'Vérifié',
      personal_email: 'Adresse e-mail personnelle',
      verify: 'Vérifier',
      reject: 'Refuser',
      more_actions: 'Plus d’actions pour {name}',
      delete_owner: 'Supprimer le propriétaire',
      rejected_with: 'Refusé avec :',
      reject_reason: 'Pourquoi refusez-vous {name} ?',
      reject_hint: 'Le propriétaire le voit sur sa page propriétaire.',
      reject_delete_everything: 'Supprimer plutôt ce propriétaire et tout ce qui lui appartient',
      reject_delete_hint: 'Supprime le compte, ses communautés et zones de fan, et retire ces communautés des abonnements des fans. Vous confirmez les détails à l’étape suivante.',
      reject_delete_continue: 'Continuer vers la suppression',
      reject_owner: 'Refuser le propriétaire',
      reject_title: 'Refuser {name} ?',
      reject_dialog_text: 'Le propriétaire peut toujours se connecter et voit votre motif sur sa page propriétaire. Vous pourrez le vérifier plus tard.',
      col_name: 'Propriétaire',
      col_organization: 'Organisation',
      ago_now: 'maintenant',
      ago_min: '{n} min',
      ago_hours: '{n} h',
      ago_days: '{n} j',
      ago_months: '{n} mois',
      ago_years: '{n} an',
      change_status: 'Changer le statut',
      set_pending: 'Remettre en attente',
      pending_done: '{name} est de nouveau en attente',
      undo: 'Annuler',
      col_email: 'E-mail',
      col_status: 'Statut',
      show_reason: 'Afficher le motif',
      col_registered: 'Inscrit',
      col_communities: 'Communautés',
      col_actions: 'Actions',
      col_area: 'Zone',
      col_area_drawn: 'limite dessinée',
      col_fan_zone: 'Zone de fans',
      fan_zone_col_area: 'zone',
      fan_zone_col_proposal: 'recommandé',
      fan_zone_title: 'Qui compte comme fan',
      fan_zone_none: 'Pas de zone de fans : les fans comptent à l’intérieur de la limite de la zone.',
      fan_zone_size: 'Zone de fans : {size}',
      fan_zone_position: 'Position : {position}',
      fan_zone_vs_start: '{change} par rapport à recommandé',
      fan_zone_start: 'Recommandé : {size}',
      fan_zone_area: 'Zone : {size}',
      fan_zone_fans_waiting: 'Approuver ajoute {count} fans',
      fan_zone_fans: 'Fans dans la zone : {count}',
      fan_zone_failed: 'La zone de fans n’a pas pu être chargée.',
      col_verified: 'Vérifiée',
      delete_title: 'Supprimer {name} ?',
      delete_text: 'Cela supprime définitivement le compte propriétaire, et :',
      delete_no_communities: 'aucune communauté',
      delete_measures: 'aucune zone de fan | 1 zone de fan | {count} zones de fan',
      delete_type_to_confirm: 'Saisissez {name} pour confirmer',
      delete_word: 'SUPPRIMER',
      delete_final: 'Cette action est irréversible.',
      delete_confirm: 'Supprimer le propriétaire | Supprimer le propriétaire et 1 communauté | Supprimer le propriétaire et {count} communautés',
      verified_done: '{name} est vérifié',
      rejected_done: '{name} est refusé',
      deleted_done: '{name} est supprimé',
      community_verified: 'Communauté {title} vérifiée',
      community_reject: 'Refuser',
      community_reject_title: 'Refuser la communauté',
      community_reject_text: 'La communauté reste active pour ses fans. Le propriétaire voit votre motif sur son tableau de bord.',
      community_reject_reason: 'Pourquoi refusez-vous {title} ?',
      community_rejected: 'Refusée',
      community_changed: 'modifiée',
      community_changed_was_verified: 'Nouvelle limite le {date} ; était vérifiée',
      community_changed_was_rejected: 'Nouvelle limite le {date} ; était refusée',
      community_rejected_done: 'Communauté {title} refusée',
      community_reject_delete: 'Supprimer plutôt cette communauté',
      community_reject_delete_hint: 'Pour les communautés fictives ou de test. Vous verrez à l’étape suivante ce qui sera supprimé.',
      community_delete_title: 'Supprimer {title} ?',
      community_delete_text: 'Cela supprime définitivement la communauté, et :',
      community_delete_fans: 'aucun fan ne perd son abonnement | 1 fan perd son abonnement | {count} fans perdent leur abonnement',
      community_delete_content: 'aucun message, sondage, réunion ou promesse | 1 message, sondage, réunion ou promesse | {count} messages, sondages, réunions et promesses',
      community_delete_official: 'la zone officielle {name} redevient disponible',
      community_delete_confirm: 'Supprimer la communauté',
      community_delete_reason: 'Motif pour le propriétaire',
      community_delete_reason_hint: 'Le propriétaire le voit sur son tableau de bord.',
      community_deleted_done: 'La communauté {title} est supprimée'
    },
    maintenance: {
      title: 'Maintenance',
      subtitle: 'Tâches ponctuelles sur les données pour les superadmins. Chaque exécution est journalisée sur le serveur.',
      environment: {
        dev: 'Développement',
        test: 'Test',
        production: 'Production'
      },
      load_failed: 'Impossible de charger les tâches de maintenance',
      retry: 'Réessayer',
      empty: 'Il n\'y a aucune tâche de maintenance.',
      status: 'État actuel',
      last_result: 'Résultat de {action} ({time})',
      unavailable: 'Indisponible dans l\'état actuel',
      buttons: 'Ce que font les boutons',
      run_failed: 'La tâche a échoué',
      run_done: '{action} terminé',
      confirm_title: 'Êtes-vous sûr ?',
      confirm_message: 'Vous allez exécuter « {action} » de « {task} » sur cet environnement.',
      confirm_changes: 'Cela modifie des données.',
      confirm_button: 'Exécuter',
      cancel: 'Annuler',
      yes: 'Oui',
      no: 'Non',
      todo_title: 'À faire sur ce serveur',
      todo_none: 'Rien à faire sur ce serveur.',
      all_apply: 'Tout exécuter',
      all_only_after: 'Tout exécuter ne fait alors que corriger et contrôler les formes.',
      all_confirm: 'D’abord la simulation de chaque étape. Si elle réussit, ces étapes s’exécutent l’une après l’autre, dans cet ordre :',
      all_confirm_order: 'Si la simulation échoue, rien ne change et vous voyez pourquoi. Une étape qui échoue ensuite arrête la suite ; les étapes d’avant restent faites. La réduction à un échantillon n’en fait pas partie : elle garde son propre bouton. Sur la production, faites d’abord une sauvegarde de la base.',
      all_result_apply: 'Tout exécuter ({time})',
      'all_result_dry-run': 'Simulation échouée, rien n’a changé ({time})',
      all_no_dry_run: 'Pas de simulation : cette étape s’exécute simplement.',
      all_done: 'Tout est exécuté',
      'all_failed_dry-run': 'Simulation échouée à {step} : rien n’a changé',
      all_failed_apply: 'Arrêté : {step} a échoué',
      lists_title: 'Listes de zones',
      per_list: 'Une liste à la fois',
      per_list_hint: 'Essai, import, suppression ou réduction d’une seule liste. D’habitude, Importer toutes les listes ci-dessus suffit.',
      other_tools: 'Autres outils',
      // a test error for Sentry (#320)
      sentry: {
        title: 'Erreur de test Sentry',
        description: 'Provoque une vraie erreur sur cette page, comme le ferait un bug. Dans Sentry, elle doit montrer cet environnement et cette version, vous comme utilisateur (id et e-mail), et le fichier et la ligne dans src/pages/AdminMaintenancePage.vue.',
        off: 'Sentry est désactivé sur dev : l’erreur va seulement dans la console du navigateur et logs/browser.log.',
        button: 'Provoquer une erreur de test',
        col_release: 'Version',
        col_event: 'Événement Sentry',
        sent: 'Erreur de test envoyée à Sentry : événement {id}',
        thrown: 'Erreur de test provoquée (Sentry est désactivé ici)'
      },
      col_list: 'Liste',
      col_version: 'Version vue par les propriétaires',
      col_bundle: 'Paquet le plus récent',
      col_entries: 'Entrées',
      entries_note: 'Entrées : tout ce que contient la liste. Les filtres de Trouvez votre zone en comptent moins : une zone qui figure aussi dans une autre liste n’y compte qu’une fois, sous une seule liste.',
      col_state: 'État',
      state_current: 'À jour',
      state_newer: 'Paquet plus récent',
      state_not_imported: 'Non importée',
      state_sample: 'Échantillon',
      state_no_bundle: 'Pas de paquet',
      details: 'Détails',
      tasks: {
        'pledge-points-to-areas': {
          todo: {
            apply: '{points} promesses ont un point comme lieu : transforme-les en petites zones.'
          },
          title: 'Points des promesses en zones',
          description: 'Donne à chaque promesse dont le lieu est un simple point une petite zone ronde (50 m) autour de ce point, car l’assistant des promesses ne dessine que des zones. Le propriétaire peut la redessiner. Faites une sauvegarde de la base avant d’appliquer en production.',
          help: {
            'dry-run': 'Compte les promesses avec un point. Ne change rien.',
            apply: 'Transforme ces points en zones et les retient, pour qu’Annuler puisse revenir en arrière.',
            rollback: 'Remet les points sur les promesses dont la zone est encore celle d’Appliquer ; une zone redessinée par un propriétaire reste.'
          },
          actions: {
            'dry-run': 'Essai',
            apply: 'Appliquer',
            rollback: 'Annuler'
          },
          fields: {
            points: 'Promesses avec un point',
            communities: 'Communautés concernées',
            applied: 'Modifiées par Appliquer (annulables)',
            changed: 'Promesses modifiées',
            restored: 'Points remis',
            redrawn: 'Redessinées depuis (laissées telles quelles)',
            unreadable: 'Points illisibles (laissés tels quels)',
            rolledBack: 'Annulé (plus de tâche ; Appliquer reste possible)',
            gone: 'Supprimées depuis (rien à remettre)'
          },
          unavailable: {
            'no-points': 'Aucune promesse n’a de point.',
            'nothing-applied': 'Rien d’appliqué à annuler.'
          }
        },
        'fan-subscriptions-cleanup': {
          todo: {
            apply: '{fans} fans suivent une communauté supprimée ou une communauté en double : nettoyez leurs abonnements.'
          },
          title: 'Nettoyage des abonnements des fans',
          description: 'Nettoie une fois les abonnements des fans : les abonnements à des communautés qui n\'existent plus disparaissent, et une communauté suivie plusieurs fois par un fan n\'est gardée qu\'une fois. Les scores des fans restent inchangés. Faites une sauvegarde de la base de données avant d\'appliquer en production.',
          help: {
            'dry-run': 'Compte ce qui changerait. Ne change rien.',
            apply: 'Nettoie ces abonnements. Un fan qui s\'abonne entre l\'essai et Appliquer sera traité au prochain passage. En production, faites d\'abord une sauvegarde de la base de données.'
          },
          actions: {
            'dry-run': 'Essai',
            apply: 'Appliquer'
          },
          fields: {
            fans: 'Fans à nettoyer',
            fansWithGone: 'Fans suivant une communauté supprimée',
            gone: 'Abonnements à des communautés supprimées',
            fansWithDuplicates: 'Fans suivant une communauté plusieurs fois',
            duplicates: 'Abonnements en double',
            changed: 'Fans nettoyés',
            skipped: 'Fans ignorés (modifiés entre-temps : relancer)',
            landsWithoutId: 'Communautés sans identifiant'
          },
          unavailable: {
            clean: 'Rien à nettoyer.',
            'lands-without-id': 'Impossible : {landsWithoutId} communautés n’ont pas d’identifiant, leurs abonnements ne se distinguent donc pas de ceux des communautés supprimées.'
          }
        },
        'area-facts': {
          warnings: {
            none: 'Les faits sur les zones sont activés, mais il n’y a encore aucun fait : téléchargez les contours, construisez un paquet avec build.py et importez-le (docs/claude/explain/area-facts.md).',
            missing: 'Communautés sans faits sur la zone : {n}. Ils arrivent avec le prochain paquet construit à partir des contours de ce site (télécharger les contours, build.py, importer).'
          },
          todo: {
            import: 'Un nouveau paquet de faits sur les zones attend : {bundle}. Importez-le.'
          },
          title: 'Faits sur les zones',
          description: 'Les faits de chaque communauté et de chaque lieu de fan issus de données ouvertes (occupation du sol, aires protégées, observations GBIF), calculés hors ligne par docs/claude/polygon-lists/area-facts/build.py à partir des limites téléchargées ici, et affichés sur la page Faits sur la zone d’une communauté. Les téléchargements : les limites pour le constructeur (un fan seulement sous pseudonyme) et l’export de recherche en CSV ou GeoJSON (livre de codes : docs/claude/explain/area-facts.md).',
          help: {
            'switch-on': 'Active l’expérience : la page des faits sur la zone, son entrée dans le menu Communautés et les téléchargements.',
            'switch-off': 'Désactive l’expérience : la page, l’entrée du menu et les téléchargements disparaissent ; les faits restent (Supprimer les efface).',
            'dry-run': 'Lit le paquet le plus récent et compte ce qu’Importer garderait et refuserait. Ne change rien.',
            import: 'Remplace les faits par ceux du paquet le plus récent.',
            remove: 'Supprime tous les faits sur les zones.',
            'download-outlines': 'La limite de chaque communauté et lieu de fan, pour build.py : un fan seulement sous pseudonyme, sans nom ni e-mail.',
            'download-csv': 'Une ligne par communauté et lieu de fan : les faits, les réponses du lieu, aucun champ personnel.',
            'download-geojson': 'Les mêmes lignes avec leurs limites.'
          },
          actions: {
            'switch-on': 'Activer',
            'switch-off': 'Désactiver',
            'dry-run': 'Essai',
            import: 'Importer',
            remove: 'Supprimer',
            'download-outlines': 'Télécharger les limites',
            'download-csv': 'Télécharger le CSV',
            'download-geojson': 'Télécharger le GeoJSON'
          },
          fields: {
            on: 'Activée',
            bundle: 'Paquet le plus récent',
            imported: 'Paquet importé',
            importedAt: 'Importé le',
            records: 'Faits',
            refused: 'Refusés',
            withoutFacts: 'Sans faits',
            lands: 'Communautés',
            places: 'Lieux de fans',
            file: 'Fichier',
            size: 'Taille (octets)',
            version: 'Version',
            removed: 'Supprimés'
          },
          unavailable: {
            off: 'L’expérience est désactivée : activez-la d’abord.',
            no_bundle: 'Pas encore de paquet dans _area-facts/bundles.',
            nothing: 'Aucun fait sur les zones importé.'
          }
        },
        'log-sessions': {
          todo: {
            apply: '{rows} lignes de journal contiennent le jeton de connexion d\'un fan comme session : remplacez-les.'
          },
          title: 'Jetons de connexion dans les journaux',
          description: 'Jusqu\'à #577, l\'assistant d\'ajout de zone et l\'enquête de financement enregistraient le jeton de connexion du fan comme session de chaque ligne ; il permettait de se connecter en tant que ce fan. Remplace chaque session de ce type par un identifiant aléatoire ; les lignes d\'une même connexion restent ensemble.',
          help: {
            'dry-run': 'Compte les lignes et les sessions. Ne change rien.',
            apply: 'Remplace ces sessions par des identifiants aléatoires. Irréversible, et c\'est voulu.'
          },
          actions: {
            'dry-run': 'Essai',
            apply: 'Appliquer'
          },
          fields: {
            rows: 'Lignes avec un jeton de connexion',
            sessions: 'Sessions (visites)'
          },
          unavailable: {
            clean: 'Rien à remplacer.'
          }
        },
        'score-duplicates': {
          todo: {
            apply: '{extra} réglages de score existent en double (un import de données) : supprimez les copies en trop.'
          },
          title: 'Réglages de score en double',
          description: 'Supprime la seconde copie des réglages de score (Dessiner une zone, Financement virtuel, Commentaire de discussion, Promesse) laissée par un import de données : la page Scores affichait chacun deux fois, et une modification n’atteignait qu’une copie. Garde la copie du serveur de test, sinon la première. Un réglage dont les copies diffèrent vous est laissé. Chaque copie supprimée est conservée : Annuler les remet. Tout exécuter l’exécute après un déploiement ; après Annuler, il attend Appliquer à la main.',
          help: {
            'dry-run': 'Liste les réglages en double et compte les copies qu’Appliquer supprimerait. Ne change rien.',
            apply: 'Supprime les copies en trop ; une par réglage est gardée.',
            rollback: 'Remet chaque copie qu’Appliquer a supprimée.'
          },
          actions: {
            'dry-run': 'Essai',
            apply: 'Appliquer',
            rollback: 'Annuler'
          },
          fields: {
            extra: 'Copies en trop',
            keys: 'Réglages en double',
            differing: 'Copies qui diffèrent (laissées telles quelles)',
            removed: 'Copies supprimées',
            appliedAt: 'Dernière application',
            rolledBackAt: 'Annulé le',
            changedSince: 'Score modifié depuis',
            restored: 'Copies remises'
          },
          unavailable: {
            clean: 'Rien en double.',
            'nothing-applied': 'Rien d’appliqué à annuler.',
            'changed-since': 'Plus possible : un score a été modifié depuis Appliquer, et l’ancienne copie le doublerait avec une autre valeur.'
          },
          warnings: {
            'values-differ': 'Les copies de {keys} ont des valeurs différentes : le score dépend de la copie que renvoie la base de données. Supprimez la mauvaise copie à la main.'
          }
        },
        'owner-status-migration': {
          todo: {
            apply: 'La migration du statut des propriétaires n’a pas encore été appliquée sur ce serveur.'
          },
          title: 'Migration du statut propriétaire',
          description: 'Donne le statut en attente à chaque propriétaire existant sans statut, aussi aux propriétaires qui sont admin. Un admin vérifie ensuite chaque propriétaire à la main sur l’écran Propriétaires de terrain. Faites une sauvegarde de la base avant d’appliquer en production.',
          help: {
            'dry-run': 'Compte les propriétaires sans statut ; tous passeraient en attente. Ne change rien. Le nombre est retenu et comparé à ce qu’Appliquer modifie.',
            apply: 'Met ces propriétaires en attente, une seule fois. Ensuite : ouvrez Propriétaires de terrain, cochez « En attente depuis la migration » et vérifiez les vrais propriétaires, d’abord ceux qui ont des communautés et des fans. D’ici là, ils ne peuvent pas gérer leurs communautés. En production, faites d’abord une sauvegarde de la base.',
            rollback: 'Retire le statut à exactement les propriétaires modifiés par Appliquer. Possible seulement tant qu’aucun admin n’a vérifié ou refusé l’un d’eux : ensuite l’action se désactive d’elle-même.'
          },
          actions: {
            'dry-run': 'Essai à blanc',
            apply: 'Appliquer',
            rollback: 'Annuler la migration'
          },
          fields: {
            applied: 'Appliquée',
            appliedAt: 'Appliquée le',
            owners: 'Propriétaires',
            pending: 'Vers en attente',
            dryRunOwners: 'Propriétaires lors de l’essai à blanc précédent',
            adminDecisions: 'Décidés par un admin depuis',
            rolledBack: 'Propriétaires rétablis'
          },
          unavailable: {
            'admin-decided': 'Plus possible : un admin a déjà décidé pour {adminDecisions} des propriétaires migrés, et l’annulation annulerait ces décisions.'
          },
          warnings: {
            'count-differs': 'Appliquer a modifié {applied} propriétaires, mais l’essai à blanc précédent en comptait {dryRun}. Vérifiez sur l’écran Propriétaires de terrain que les bons propriétaires sont en attente.'
          }
        },
        'geometry-check': {
          todo: {
            never_run: 'Le contrôle des géométries n’a jamais tourné sur ce serveur.'
          },
          title: 'Contrôle des formes',
          description: 'Contrôle chaque lieu d\'un fan, chaque limite de communauté et chaque domicile : formes manquantes ou cassées, lignes qui se croisent, formes au mauvais endroit (en 0,0, latitude et longitude inversées, loin du domicile), beaucoup trop petites ou trop grandes, niveaux impossibles, doublons et formes orphelines. Lecture seule : ne change rien. Tourne en arrière-plan ; les chiffres s\'affichent ici à la fin.',
          help: {
            run: 'Contrôle la base de données de cet environnement.',
            'run-copy': 'Contrôle la copie de base de données prévue pour cela (settings : geometryCheck.copyUrl), par exemple une copie de la production sur dev.'
          },
          actions: {
            run: 'Contrôler',
            'run-copy': 'Contrôler la copie'
          },
          fields: {
            lastRun: 'Dernier contrôle',
            state: 'État',
            source: 'Base de données',
            startedAt: 'Démarré',
            finishedAt: 'Terminé',
            checked: 'Contrôlés',
            defects: 'Défauts',
            error: 'Erreur',
            started: 'Contrôle lancé'
          },
          unavailable: {
            running: 'Un contrôle est déjà en cours.',
            'no-copy': 'Aucune copie de base de données n\'est prévue.'
          }
        },
        'geometry-fix': {
          title: 'Réparer les formes',
          description: 'Répare les lieux des fans comme décidé dans l\'issue #76 : les formes dont les lignes se croisent sont démêlées, les points de double-clic retirés, les formes au-delà du bord de la carte replacées ou coupées, les lieux en 0,0 déplacés vers le domicile du fan, les copies et les lieux d\'utilisateurs supprimés effacés, les niveaux impossibles corrigés, et un fan qui a terminé son inscription reçoit un lieu à chaque niveau (ceux qui manquent sont créés autour du domicile et marqués comme créés). L\'ancienne version de chaque lieu modifié est gardée : Annuler remet tout en place.',
          help: {
            'dry-run': 'Compte ce que chaque réparation changerait dans cette base de données. Ne change rien.',
            apply: 'Fait toutes les réparations d\'un coup dans cette base de données. Sur la production, faites d\'abord une sauvegarde de la base.',
            rollback: 'Remet en place tout ce que le dernier Appliquer a changé, à partir des anciennes versions gardées.',
            'dry-run-copy': 'Essai sur la copie de la base de données (settings : geometryCheck.copyUrl).',
            'apply-copy': 'Appliquer sur la copie de la base de données.',
            'rollback-copy': 'Annuler sur la copie de la base de données.'
          },
          actions: {
            'dry-run': 'Essai',
            apply: 'Appliquer',
            rollback: 'Annuler',
            'dry-run-copy': 'Essai (copie)',
            'apply-copy': 'Appliquer (copie)',
            'rollback-copy': 'Annuler (copie)'
          },
          fields: {
            lastRun: 'Dernière application',
            lastRunCopy: 'Dernière application sur la copie',
            run: 'Exécution',
            changes: 'Modifications',
            left: 'Impossible à corriger'
          },
          unavailable: {
            'no-copy': 'Aucune copie de base de données n\'est prévue.',
            'nothing-applied': 'Rien n\'a été appliqué à annuler.'
          }
        },
        'polygon-lists': {
          title: 'Toutes les listes de zones',
          description: 'Importe en une fois chaque liste ayant un paquet plus récent, puis applique une fois les groupes de zones.',
          help: {
            'import-all': 'Importe le paquet le plus récent de chaque liste qui en a un plus récent que celui des propriétaires (ou jamais importée), l’une après l’autre, puis applique une fois les groupes de zones. Les listes à jour sont ignorées. Les grandes listes (WDPA) prennent de nombreuses minutes.',
            'prune-all': 'Serveur de test uniquement. Réduit chaque liste complète à son échantillon d’environ 100 zones (toujours les mêmes) ; les zones avec une communauté restent.'
          },
          actions: {
            'import-all': 'Importer toutes les listes',
            'prune-all': 'Réduire toutes les listes à des échantillons'
          },
          fields: {
            lists: 'Listes',
            active: 'Listes proposées aux propriétaires',
            withBundle: 'Listes avec un paquet',
            toPrune: 'Listes complètes à réduire',
            toImport: 'Paquets plus récents à importer',
            samples: 'Listes qui sont des échantillons',
            imported: 'Importées',
            pruned: 'Réduites à un échantillon',
            groups: 'Groupes de zones',
            groupsFile: 'Fichier des groupes de zones'
          },
          unavailable: {
            all_current: 'Chaque liste est à jour.',
            all_samples: 'Chaque liste est déjà un échantillon.',
            no_bundles: 'Il n’y a pas de paquets dans le dossier d’import.',
            nothing_imported: 'Aucune liste n’a encore été importée.',
            small_lists: 'Les listes complètes ont 100 entrées ou moins.'
          },
          todo: {
            import: 'Nouveaux paquets à importer : {lists}.'
          }
        },
        'polygon-list': {
          title: 'Liste de polygones : {list}',
          description: 'Importe cette liste de polygones depuis le paquet le plus récent de son dossier (<dossier d’import>/<liste>/bundles), vérifié avec son fichier .sha256. Une liste a une seule version : Importer charge les nouvelles entrées à côté des anciennes, bascule la liste quand tout est chargé, puis supprime les anciennes. Il n’y a pas de retour en arrière : pour revenir, placez un paquet plus ancien dans le dossier et importez-le. Les communautés gardent leur propre limite et leurs informations, quoi qu’il arrive à la liste.',
          help: {
            'dry-run': 'Lit le paquet le plus récent et vérifie chaque entrée. Indique le nombre d’entrées, par statut, et les éventuels problèmes. Ne change rien.',
            import: 'Importe le paquet le plus récent et en fait la version proposée aux propriétaires, à la place de la précédente. Refusé si une entrée pose problème (voir Essai) ; rien ne change alors.',
            remove: 'Retire la liste aux propriétaires et supprime toutes ses entrées. Les communautés qui l’utilisent gardent leur limite et leurs informations.',
            prune: 'Serveur de test uniquement. Garde environ 100 zones variées de cette liste (statuts, tailles, premières lettres, pays, avec et sans contour fan) et supprime le reste, pour que le test reste petit et rapide. Toujours les mêmes zones. Les zones sur lesquelles se trouve une communauté sont toujours gardées. Pour retrouver la liste complète : l’importer à nouveau.'
          },
          actions: {
            'dry-run': 'Essai',
            import: 'Importer',
            remove: 'Supprimer la liste',
            prune: 'Réduire à un échantillon'
          },
          fields: {
            listKey: 'Liste',
            bundle: 'Paquet le plus récent',
            bundleMB: 'Taille (Mo)',
            activeDatasetVersion: 'Version pour les propriétaires',
            importedFile: 'Paquet importé',
            importedAt: 'Importé le',
            entries: 'Entrées dans la base',
            file: 'Fichier',
            sha256: 'Somme de contrôle',
            datasetVersion: 'Version du paquet',
            withPolygon: 'Avec polygone',
            problems: 'Problèmes',
            problemExamples: 'Exemples de problèmes',
            currentVersion: 'Version actuelle',
            currentEntries: 'Entrées actuelles',
            official: 'Limite officielle',
            accepted: 'Acceptée',
            partial: 'Zone centrale seulement',
            proxy: 'Zone approximative',
            review: 'À vérifier (le propriétaire dessine)',
            missing: 'Sans polygone (le propriétaire dessine)',
            imported: 'Importées',
            removedOld: 'Anciennes entrées supprimées',
            communities: 'Communautés sur cette liste',
            aliases: 'Copies fusionnées dans une autre entrée (alias)',
            movedCommunities: 'Communautés déplacées d’une copie vers son entrée',
            notMovedCommunities: 'Communautés restées sur une copie (son entrée en a déjà une)',
            removed: 'Entrées supprimées',
            listRemoved: 'Liste supprimée',
            groupedEntries: 'Zones dans un groupe',
            groupsFile: 'Fichier des groupes de zones',
            groups: 'Groupes de zones',
            groupsError: 'Groupes de zones non appliqués',
            prunedAt: 'Réduite à un échantillon le',
            prunedFrom: 'Entrées avant la réduction',
            kept: 'Entrées gardées',
            sample: 'Dans l’échantillon',
            keptInUse: 'Gardées car une communauté s’y trouve'
          },
          unavailable: {
            no_bundle: 'Il n’y a pas de paquet dans le dossier de cette liste.',
            not_imported: 'La liste n’a pas encore été importée.',
            already_pruned: 'La liste est déjà un échantillon. Importez-la à nouveau pour la liste complète.',
            small_list: 'La liste a déjà 100 entrées ou moins.'
          },
          warnings: {
            groups_stale: 'Les groupes de zones ({file}) ont été faits pour une autre version de la liste « {list} » : ses zones ne sont dans aucun groupe. Lancez groups.py pour les listes telles qu’elles sont et copiez le nouveau fichier dans le dossier _groups.',
            groups_waiting: 'Un fichier de groupes de zones plus récent ({file}) se trouve dans le dossier _groups : il sera appliqué au prochain import d’une liste ou au démarrage du serveur.'
          }
        }
      }
    },
    home: {
      title: 'Accueil'
    },
    moderators: {
      title: 'Modérateurs',
      mod_requests: 'Demandes de modérateur',
      mods: 'Modérateurs',
      accept: 'Accepter',
      deny: 'Refuser'
    },
    create_community: {
      title: 'Créer une communauté'
    },
    land_owner_register: {
      title: 'Inscription du propriétaire foncier',
      steps: {
        general: {
          nav_title: 'Informations générales',
          title: 'Informations sur le propriétaire foncier',
          task_title: 'Fournissez des informations générales sur le terrain que vous possédez',
          email: 'E-mail'
        },
        draw: {
          nav_title: 'Carte',
          title: 'Dessiner la zone',
          task_title: 'Dessinez votre zone'
        },
        description: {
          nav_title: 'Description',
          title: 'Décrivez votre communauté',
          task_title: 'Indiquez un titre qui représente votre communauté',
          input_title: 'Titre',
          input_title_error: '{max} caractères maximum',
          input_description: 'Description',
          task_description: 'Décrivez ce qui rend cette communauté attrayante, précieuse ou importante',
          input_description_error: '{max} caractères maximum'
        },
        finalize: {
          title: 'Informations',
          task_title: 'Merci d\'avoir fourni ces informations. Si vous cliquez sur suivant, nous finaliserons votre communauté. Pour discuter de sujets avec votre communauté, vous pouvez ouvrir une discussion. Cliquez sur les 3 points à droite de « discussions » pour ajouter une nouvelle discussion et aborder un nouveau sujet.'
        }
      }
    },
    pledge: {
      count: 'Nombre total de donateurs',
      part1: 'promis sur',
      part2: 'objectif',
      question: 'Souhaitez-vous <b>promettre</b> vos fonds virtuels à ce projet ?',
      yes: 'Oui, je <b>veux</b> soutenir ce projet',
      no: 'Non, je <b>ne veux pas</b> soutenir ce projet',
      delete_title: 'Supprimer la promesse de don',
      delete_text: 'Voulez-vous vraiment supprimer cette promesse de don ?'
    },
    add_pledge: {
      title: 'Indiquez le montant que vous souhaitez promettre à ce projet.',
      reason: 'Pourriez-vous expliquer pourquoi vous avez choisi ce montant ?',
      reasonNo: 'Pourriez-vous expliquer pourquoi vous ne souhaitez pas soutenir ce projet ?',
      confirm_text1: 'Vous proposez actuellement de promettre',
      confirm_text2: 'de votre budget nature annuel indiqué à ce projet. Pourriez-vous confirmer ce montant ?',
      confirm: 'Je confirme',
      description: 'texte à venir',
      budget_hint: 'Votre budget nature : {amount} € par an'
    },
    add_treasure: {
      title_nav: 'Ajouter un trésor',
      photos: 'Photos',
      title: 'Téléchargez des photos de trésors',
      description: 'Montrez pourquoi vous aimez ce lieu. Partagez un dessin, un poème, une photo ou une courte histoire.',
      upload: 'Télécharger des photos (.jpg)',
      describe_title: 'Donnez un titre à votre trésor',
      describe_text: 'Dites avec vos mots ce qui rend ce trésor attrayant, précieux ou important pour vous',
      pin_hint: 'Touchez la carte là où se trouve votre trésor.',
      pin_move: 'Faites glisser l\'épingle ou touchez ailleurs pour la déplacer.',
      pin_outside: 'Cet endroit se trouve en dehors de la zone de la communauté.',
      show_area: 'Afficher toute la zone'
    },
    create_pledge: {
      title_nav: 'Ajouter une demande de financement',
      title: 'Décrivez votre demande de financement avec un titre accrocheur.',
      description: 'Décrivez votre demande de financement plus en détail. Donnez le contexte, les actions proposées, les résultats envisagés et ce que vos donateurs recevront en retour.',
      type: 'Type de financement',
      fixed: 'Unique',
      fixed_desc: 'Demande de financement ponctuel',
      yearly: 'Annuel',
      yearly_desc: 'Demande de financement répété chaque année',
      '2yearly': 'Tous les 2 ans',
      '2yearly_desc': 'Demande de financement répété tous les 2 ans',
      '3yearly': 'Tous les 3 ans',
      '3yearly_desc': 'Demande de financement répété tous les 3 ans',
      '4yearly': 'Tous les 4 ans',
      '4yearly_desc': 'Demande de financement répété tous les 4 ans',
      '5yearly': 'Tous les 5 ans',
      '5yearly_desc': 'Demande de financement répété tous les 5 ans',
      goal: 'Indiquez votre objectif de financement en euros.',
      goal_error: 'Au maximum € {max}',
      map_title: 'Dessinez la zone de votre promesse de don',
      map_outside: 'Une partie de votre zone se trouve en dehors de la zone de la communauté.'
    },
    edit_pledge: {
      title_nav: 'Modifier la demande de financement'
    },
    create_message: {
      sent: 'Le message a été envoyé',
      no_communities: 'Aucune communauté',
      title_nav: 'Créer un message',
      steps: {
        community: {
          nav_title: 'Communauté',
          ask: 'Choisissez la <b>communauté</b> à laquelle envoyer le message. Il va à <b>tous</b> ses membres.',
          title: 'Sélectionnez la <b>communauté</b> pour envoyer le message à <b>tous ses fans</b>'
        },
        message: {
          nav_title: 'Message',
          title_ask: 'Donnez à votre message un titre court et accrocheur.',
          body_ask: 'Décrivez de quoi il s\'agit, donnez le contexte et dites ce que vous attendez des membres. Restez bref et précis.'
        },
        finalize: {
          nav_title: 'Finaliser',
          ask: 'Voici comment les membres de la communauté le verront.'
        }
      }
    },
    create_thread: {
      title_nav: 'Créer une discussion',
      title_nav_edit: 'Modifier la discussion',
      title: 'Indiquez un titre',
      description: 'Rédigez un premier message',
      options: 'Ajouter des options de sondage',
      option: 'option',
      upload: 'Télécharger des photos (.jpg)'
    },
    create_poll: {
      preview: 'Aperçu',
      title_nav: 'Créer un sondage',
      title_nav_edit: 'Modifier le sondage',
      title: 'Indiquez un titre',
      description: 'Rédigez un premier message',
      upload: 'Télécharger des photos (.jpg)',
      options: 'Ajouter des options de sondage',
      option: 'option'
    },
    create_polis: {
      id_label: 'Identifiant Polis',
      title_nav: 'Créer un Polis',
      title_nav_edit: 'Modifier le Polis',
      title: 'Indiquez un titre',
      id: 'Indiquez un identifiant Polis',
      voter_option: 'Seuls les utilisateurs abonnés peuvent voter'
    },
    create_meeting: {
      date: 'Date',
      time: 'Heure',
      title_nav: 'Créer une réunion',
      title_nav_edit: 'Modifier la réunion',
      title: 'Indiquez un titre',
      description: 'Indiquez une description',
      url: 'Indiquez l\'URL externe de la réunion',
      dateTime: 'Heure et date de début'
    },
    send_invites: {
      title_nav: 'Envoyer les invitations',
      step: 'Choisir',
      number: 'Nombre de membres invités au hasard',
      number_label: 'Nombre d\'invitations',
      max_error: 'Au plus {max} invitations',
      sent: 'Les e-mails ont été envoyés'
    },
    meeting: {
      deleted: 'La réunion a été supprimée',
      delete_title: 'Supprimer la réunion',
      delete_text: 'Voulez-vous vraiment supprimer cette réunion ?',
      total_subs: 'Nombre total d\'abonnés',
      accepted_invites: 'Invitations acceptées',
      rejected_invites: 'Invitations déclinées',
      planned_label: 'prévue le',
      invited_banner: 'Vous avez été invité à la réunion',
      accepted_banner: 'Vous avez accepté l\'invitation. Si vous êtes sélectionné, vous recevrez un e-mail avec plus de détails sur la réunion.',
      rejected_banner: 'Vous avez décliné l\'invitation à la réunion',
      send_banner: 'Envoyez le lien de la réunion aux abonnés qui ont accepté l\'invitation.',
      resend_banner: 'Renvoyez le lien de la réunion. Attention : vous avez déjà envoyé les liens !'
    },
    landing: {
      my_portal: 'Mon Xena'
    },
    welcome: {
      // the links between the visitor's pages (#442)
      no_account: 'Pas encore de compte ?',
      to_register: 'Créer un compte',
      have_account: 'Déjà un compte ?',
      to_login: 'Se connecter',
      back_to_login: 'Retour à la connexion',
      title: 'Bienvenue sur Greenmapper Friends',
      introduction: 'Introduction',
      subtitle_1: 'Marquez des lieux de nature et de paysage',
      paragraph_1: 'Sur Greenmapper Friends, vous pouvez marquer des lieux naturels que vous trouvez attrayants, précieux ou importants. Ces zones doivent être des lieux avec de la verdure, de l\'eau ou de la nature. Pensez à un endroit dans un parc, au bord d\'un lac, à la mer, dans une forêt, une prairie, un champ de fleurs, un endroit pour observer les oiseaux, etc. Il peut s\'agir d\'un lieu en ville ou en dehors, petit ou grand. Vous pouvez y aller souvent ou jamais ! Du moment que c\'est un lieu naturel que vous trouvez attrayant, précieux ou qui a du sens pour vous.',
      subtitle_2: 'Pourquoi s\'inscrire ?',
      paragraph_2: 'L\'idée est que vous indiquiez vos espaces naturels préférés dont vous souhaitez être l\'ami. C\'est pourquoi nous vous posons quelques questions pour créer votre compte. Votre adresse e-mail n\'est pas affichée dans l\'application, seulement votre nom d\'affichage.',
      subtitle_3: 'Politique de confidentialité',
      paragraph_3: 'Greenmapper Friends est une initiative de l\'Université de Groningue. Greenmapper Friends enregistre votre adresse e-mail dans le Greenmapper Landscape Friend Registry (GLFR). Personne d\'autre que l\'organisation Greenmapper n\'a accès à cette adresse e-mail. Via le GLFR, les propriétaires fonciers, les gestionnaires de terrains ou d\'autres amis de la zone peuvent vous contacter de manière anonyme. Ces tiers n\'ont cependant pas d\'accès direct à votre adresse e-mail. Nous suivons les directives du Règlement général européen sur la protection des données pour la vie privée et le stockage de vos données personnelles.',
      continue_without_account: 'Continuer sans compte',
      forgot_password: 'Mot de passe oublié ?',
      forgot_password_dialog: 'Saisissez votre adresse e-mail. Vous recevrez un lien pour choisir un nouveau mot de passe.'
    },
    introduction: {
      title: 'Introduction',
      text: 'Sur Greenmapper Friends, vous pouvez marquer des lieux naturels que vous trouvez attrayants, précieux ou importants. Ces zones doivent être des lieux avec de la verdure, de l\'eau ou de la nature. Pensez à un endroit dans un parc, au bord d\'un lac, à la mer, dans une forêt, une prairie, un champ de fleurs, un endroit pour observer les oiseaux, etc. Il peut s\'agir d\'un lieu en ville ou en dehors, petit ou grand. Vous pouvez y aller souvent ou jamais ! Du moment que c\'est un lieu naturel que vous trouvez attrayant, précieux ou qui a du sens pour vous.',
      start_btn: 'Commencer l\'enquête'
    },
    register: {
      email_sublabel: 'non visible par les autres',
      name_sublabel: 'visible par les autres',
      name_hint: 'par exemple un pseudonyme ou un prénom',
      address_search_sublabel: '±200 m suffisent',
      password_hint: '8 caractères minimum',
      map_preview_hint: 'Sélectionnez un lieu de résidence pour le prévisualiser sur la carte',
      use_my_location: 'Utiliser ma position',
      geolocate_failed: 'Impossible d’obtenir votre position. Vérifiez les autorisations ou recherchez manuellement.',
      location_not_found: 'Aucun lieu trouvé. Essayez une ville, une adresse ou un code postal.',
      disclaimer_title: 'Avertissement Greenmapper Friends',
      disclaimer: 'Greenmapper Friends enregistre votre adresse e-mail dans le Greenmapper Landscape Friend Registry (GLFR). Personne d\'autre que Greenmapper Friends n\'a accès à cette adresse e-mail. Via le GLFR, les propriétaires fonciers, les gestionnaires de terrains ou d\'autres amis de la zone peuvent vous contacter de manière anonyme. Ces tiers n\'ont cependant pas d\'accès direct à votre adresse e-mail ni à vos données personnelles. Nous vous demandons aussi l\'emplacement de votre domicile, uniquement pour vous montrer par défaut une carte de vos environs. Nous suivons les directives du Règlement général européen sur la protection des données pour la vie privée et le stockage de vos données personnelles. Plus de détails'
    },
    info_contact: {
      title: 'À propos',
      contact: 'Contact',
      disclaimer_title: 'Avertissement',
      implementation: 'Réalisation : '
    },
    map: {
      title: 'Carte générale des communautés',
      add_btn: 'Dessiner une nouvelle zone',
      share_title: 'Partager l\'URL de la carte',
      share_btn: 'Copier dans le presse-papiers',
      hint_on_add: 'Placez le point sur la carte pour commencer à dessiner',
      hint_on_end_draw: 'Vous pouvez encore modifier la zone.',
      zoom_to_area_btn: 'Zoomer sur la zone',
      details_btn: 'Voir les détails',
      menu_btn: 'Options de la carte',
      layers_btn: 'Carte ou satellite',
      gps_btn: 'Aller à ma position',
      home_btn: 'Aller à mon domicile'
    },
    timeline: {
      title: 'Chronologie',
      rating: 'Note',
      rating_subtext: 'Note personnelle de la zone marquée',
      visit_frequency: 'Fréquence de visite',
      visit_frequency_subtext: 'À quelle fréquence la zone est visitée',
      activities: 'Activités',
      activities_subtext: 'Activités signalées dans la zone marquée',
      add_btn: 'Ajouter une zone',
      edit_btn: 'Modifier la zone',
      delete_btn: 'Supprimer la zone',
      delete_title: 'Supprimer la zone',
      delete_subtitle: 'Êtes-vous sûr ?'
    },
    add_area_info: {
      title: 'Ajouter une zone',
      add_btn: 'Ajouter une zone'
    },
    my_areas: {
      open_btn: 'Afficher dans Google Maps',
      title: 'Mes zones',
      sub_title: 'Tous les lieux de nature que je trouve attrayants, précieux ou importants.',
      created_areas: 'Zones créées',
      joint_surface: 'Surface totale (km2)',
      and_section_eyebrow: 'Base de données Greenmapper Nature attractive',
      and_section_title: 'Vos quatre lieux préférés par échelle',
      and_complete_badge: 'Les quatre échelles complètes',
      free_section_title: 'Lieux que vous avez ajoutés vous-même'
    },
    my_communities: {
      open_btn: 'Ouvrir la communauté',
      title: 'Mes communautés',
      sub_title: 'Toutes les zones de propriétaires fonciers ou de gestionnaires de terrains qui chevauchent mes zones. Ici, je peux être contacté en tant qu\'ami de ces zones.',
      delete_btn: 'Se désabonner',
      delete_title: 'Se désabonner',
      delete_subtitle: 'Voulez-vous vraiment vous désabonner de cette communauté ?',
      befriended_communities: 'Communautés amies',
      joint_surface: 'Surface totale (km2)'
    },
    info: {
      text1: 'Greenmapper Friends est développé par Greenmapper. Pour plus d\'informations, consultez le site de Greenmapper',
      text2: 'Si vous avez des questions ou souhaitez nous contacter, envoyez-nous un e-mail à :',
      text3: 'Avec Greenmapper Friends, nous essayons de garder l\'application et les données aussi exactes et exemptes d\'erreurs que possible. Si l\'application, malgré nos efforts, contient des informations incomplètes ou inexactes, nous ne pouvons en accepter la responsabilité.',
      text4: 'Nous nous réservons le droit de modifier, supprimer ou ajouter du contenu sans préavis. Greenmapper Friends décline toute responsabilité quant aux informations contenues sur les sites web vers lesquels nous renvoyons par des liens.'
    },
    my_owned_communities: {
      title: 'Mes communautés',
      owned_communities: 'Communautés gérées',
      total_subs: 'Nombre total d\'abonnés',
      joint_surface: 'Surface totale (km2)'
    },
    community: {
      report_title: 'Signaler le commentaire',
      report_subtitle: 'Voulez-vous vraiment signaler ce commentaire pour modération ?',
      report_hint: 'Indiquez une raison',
      delete_title: 'Supprimer le commentaire',
      delete_subtitle: 'Voulez-vous vraiment supprimer ce commentaire ?',
      discussions_title: 'Discussions',
      discussions_subtitle: 'Discussion ouverte sur tout sujet',
      poll_title: 'Sondage',
      poll_subtitle: 'Sondages et votes simples sur des options',
      polis_title: 'Polis',
      polis_subtitle: 'Cliquez sur l\'un des sujets ci-dessous pour lancer un vote pol.is',
      pledges_title: 'Soutenez des projets !',
      pledges_subtitle: 'Promesses virtuelles de fonds pour la biodiversité, la qualité du paysage ou des services durables',
      meetings_title: 'Réunions',
      meetings_subtitle: 'Atelier en ligne approfondi ou conseil d\'amis',
      RMS_dialog_title: 'Demander le statut de modérateur',
      RMS_dialog_text: 'Voulez-vous envoyer une demande pour devenir modérateur de cette communauté ?',
      more_btn: "Plus d'options",
      to_map_btn: 'Voir sur la carte',
      treasures_title: 'Trésors',
      show_report_btn: 'Voir le signalement',
      join_btn: 'Rejoindre'
    },
    poll: {
      deleted: 'Le sondage a été supprimé',
      label: 'Sondage',
      delete_title: 'Supprimer le sondage',
      delete_text: 'Voulez-vous vraiment supprimer ce sondage et ses votes ?',
      votes: 'votes',
      voted: 'Vous avez voté'
    },
    polis: {
      deleted: 'La conversation Polis a été supprimée',
      delete_title: 'Supprimer la conversation Polis',
      delete_text: 'Voulez-vous vraiment retirer cette conversation Polis de la communauté ?',
      text: 'Cliquez sur « Activer la traduction tierce » pour voir les commentaires dans votre langue par défaut. Pour chaque affirmation, vous pouvez voter « d\'accord », « pas d\'accord » ou « passer/incertain ».',
      text2: 'Vous pouvez soumettre votre opinion ou affirmation, afin que d\'autres puissent voter sur vos idées.'
    },
    account: {
      edit_title: 'Modifier le profil',
      saved: 'Profil enregistré',
      signout_title: 'Se déconnecter'
    },
    create_area: {
      title: 'Créer une zone',
      add_title: 'Ajouter une zone',
      home_title: 'Placer le marqueur du domicile',
      pauze_title: 'Êtes-vous sûr ?',
      pauze_text: 'Mettre l\'inscription en pause et continuer plus tard',
      map_tips: 'Conseils pour la carte',
      search_place: 'Rechercher un lieu',
      search_not_found: 'Aucun résultat',
      zoom_smaller: 'Plus petit',
      zoom_bigger: 'Plus grand',
      area_reset: 'Réinitialiser la zone',
      reset_polygon: 'Réinitialiser le polygone',
      reset_polygon_title: 'Réinitialiser le polygone ?',
      reset_polygon_text: 'Le polygone revient à son état d\'avant vos modifications.',
      leave_polygon_edit_title: 'Abandonner les modifications du polygone ?',
      leave_polygon_edit_text: 'Revenir en arrière remet votre polygone à la sélection en cercle. Vos modifications de points seront perdues.',
      polygon_guard: {
        cross: 'Les lignes ne doivent pas se croiser',
        spacing: 'Les points ne doivent pas être trop proches',
        edge: 'Un point ne doit pas être trop proche d\'un autre côté',
        angle: 'L\'angle ne peut pas devenir aussi aigu',
        area: 'La zone ne peut pas devenir aussi petite',
        bounds: 'Le point reste dans la partie visible de la carte',
        too_few: 'La zone doit avoir au moins 3 points',
        not_closed: 'La forme n\'est pas fermée',
        duplicate: 'Deux points sont au même endroit',
        range: 'Le point se trouve en dehors de la plage valide de la carte',
        invalid: 'Cette forme ne peut pas être enregistrée'
      },
      loading: {
        title: 'Préparation de la carte',
        opening: 'Ouverture de la carte…',
        loading_account: 'Chargement du compte…',
        loading_areas: 'Chargement de vos zones…',
        loading_home: 'Chargement du domicile…'
      },
      hints: {
        place_above_area: 'Placez sur votre zone',
        place_area_here: 'Votre lieu ici',
        drag_vertex: 'Glissez les points sur votre lieu',
        zoom: 'Zoomer et dézoomer',
        at_edge: 'Vous avez atteint le bord de cette zone'
      },
      stepper: {
        description: 'Description',
        rate: 'Note',
        visit_freq: 'Fréquence de visite',
        activities: 'Activités',
        connected: 'Connecté en ligne'
      },
      steps: {
        level: {
          nav_title: 'Niveau',
          title: 'Choisir le niveau',
          task_title: 'choisissez le niveau de votre zone',
          options: {
            neighborhood: 'quartier / local',
            living_area: 'région / régional',
            country: 'pays',
            world: 'monde'
          }
        },
        map: {
          nav_title: 'Carte',
          title: 'Dessiner la zone',
          task_title: 'Dessinez votre zone'
        },
        description: {
          nav_title: 'Description',
          title: 'Décrivez votre zone',
          task_title: 'Comment appelez-vous cette zone ?',
          input_title: 'Titre',
          input_name: 'Nom',
          input_title_error: '{max} caractères maximum',
          input_description: 'Description',
          task_description: 'Pourquoi cette zone est-elle attrayante, précieuse et/ou importante ?',
          input_description_error: '{max} caractères maximum'
        },
        rate: {
          nav_title: 'Note',
          title: 'Notez votre zone',
          task_title: '(Note : 1 = mauvais, 6 = moyen, 10 = parfait)'
        },
        visit_freq: {
          nav_title: 'Visites',
          title: 'À quelle fréquence visitez-vous votre zone ?',
          options: {
            daily: 'Tous les jours',
            weekly: 'Toutes les semaines',
            monthly: 'Tous les mois',
            few_times_a_year: 'Quelques fois par an',
            yearly: 'Une fois par an',
            rarely: 'Rarement',
            never: 'Jamais'
          }
        },
        activities: {
          nav_title: 'Activités',
          title: 'Quelles activités pratiquez-vous dans cette zone ?'
        },
        priority: {
          nav_title: 'Priorité',
          title: 'Ce lieu devrait être :',
          options: {
            maintained: 'Préservé (= le garder tel quel)',
            strengthened: 'Renforcé (= améliorer ses qualités)'
          }
        },
        finished: {
          '1_title': 'Merci ! Votre premier lieu est maintenant sur la carte',
          '1_text': 'Cette première contribution nous aide déjà à mieux comprendre quels lieux naturels les gens apprécient.',
          '2_title': 'Super, votre carte personnelle prend forme',
          '2_text': 'Chaque lieu que vous ajoutez aide à rendre visible ce qui mérite d\'être protégé.',
          '3_title': 'Merci ! Votre contribution apporte déjà des informations précieuses sur la nature et le paysage',
          '3_text': 'Ajouter encore un lieu complétera votre carte.',
          '4_title': 'Formidable, votre carte personnelle est maintenant complète !',
          '4_text': 'Votre contribution aide les chercheurs et les gestionnaires à mieux comprendre quels lieux les gens veulent préserver et protéger. Vous verrez bientôt un aperçu de vos lieux. D\'abord, nous avons une courte question sur un éventuel soutien financier pour vos zones'
        },
        relationship: {
          nav_title: 'Relation',
          title: 'Quelle est votre relation avec cette zone',
          options: {
            tourist: 'Touriste',
            inhabitant: 'Habitant',
            work: 'Lié au travail'
          }
        }
      },
      _edit: {
        title: 'Mettre à jour la zone'
      },
      welcome: {
        title: 'Dessinez des zones et répondez aux questions',
        subtitle: 'Marquez quatre lieux de nature à différentes échelles et expliquez pourquoi ils comptent pour vous.',
        sheet_text: 'Consultez l\'aperçu ci-dessous. Appuyez sur Suivant pour dessiner votre première zone de quartier.',
        how_it_works_title: 'Ce que vous faites à chaque niveau',
        step_draw: 'Marquez une zone sur la carte',
        step_questions: 'Répondez à des questions sur votre lieu',
        step_next_level: 'Répétez pour 4 échelles',
        journey_title: 'Quatre échelles, quatre lieux',
        video_caption: 'Court guide pour dessiner une zone'
      },
      welcome_v3: {
        greeting: 'Bienvenue sur Greenmapper Friends',
        title: 'Marquez votre lieu de nature',
        intro: 'Marquez des lieux avec de la verdure, de l\'eau ou un paysage que vous trouvez attrayants, précieux ou importants.',
        levels_title: 'Quatre échelles',
        levels_intro: 'Choisissez un lieu à chaque niveau.',
        checklist_title: 'Ce que vous faites à chaque niveau',
        step_draw: 'Dessinez le lieu comme une zone sur la carte.',
        step_adjust: 'Ajustez la forme et confirmez la zone.',
        step_questions: 'Répondez à quelques questions sur l\'importance de ce lieu pour vous.',
        step_repeat: 'Répétez ces étapes pour l\'échelle suivante.',
        repeat_hint: 'Vous commencez dans votre quartier. Après les questions, continuez avec la région, le pays et le monde.',
        start_btn: 'Commencer par le quartier'
      },
      welcome_v4: {
        title: 'Marquez votre lieu de nature',
        title_next: 'Lieu suivant : {level}',
        intro: 'Marquez des lieux avec de la verdure, de l\'eau ou un paysage que vous trouvez attrayants, précieux ou importants.',
        intro_next: 'Continuez avec {level}. Marquez un lieu avec de la verdure, de l\'eau ou un paysage que vous trouvez attrayant, précieux ou important.',
        checklist_title: 'Ce que vous faites à chaque niveau',
        start_badge: 'Début',
        now_badge: 'Maintenant',
        done_badge: 'Fait',
        progress: 'Lieu {current} sur 4',
        start_btn: 'Commencer par {level}',
        continue_btn: 'Continuer avec {level}'
      },
      stop_title: 'Arrêter l\'inscription et terminer plus tard'
    },
    edit_area: {
      title: 'Mettre à jour la zone'
    },
    funding: {
      not_eligible: 'Malheureusement, vous ne pouvez pas participer au questionnaire de financement : il porte sur au moins deux de vos propres zones.',
      title: 'Fonds virtuels Nature & Communauté',
      // the wizard's bar (the whole name was cut off, the user's review of #493)
      title_nav: 'Fonds nature',
      nav_intro: 'Introduction',
      nav_amount: 'Montant',
      nav_locations: 'Lieux',
      nav_objectives: 'Objectifs',
      nav_finalize: 'Finaliser',
      intro1: 'Bonjour !',
      intro2: 'Merci de participer à l\'expérience Greenmapper sur le financement de la nature.',
      intro3: 'Dans cette section, vous utilisez un <b>Fonds virtuel Nature & Communauté</b>. Vous montrez comment vous répartiriez un budget nature annuel <b>hypothétique</b>, <b>sans réellement payer</b>. Avec les autres participants, cela aide les gestionnaires et les décideurs à comprendre ce que les gens trouvent important.',
      intro4: '<h6>Comment ça marche, en 3 étapes :</h6>',
      step1: 'Confirmez votre budget nature annuel total',
      step2: 'Répartissez-le entre vos 4 zones',
      step3: 'Répartissez par zone entre les objectifs : biodiversité, paysage, entreprise durable, culture, autre',
      caption: 'Tronc = zone • Branches = objectifs • Pommes = exemples de projets.',
      intro5: '<b>En pratique</b> : 5–8 min • anonyme • pas de bonnes ou mauvaises réponses.',
      intro6: 'En remerciement, <b>nous faisons un don de 5 € pour la nature sur Texel </b> une fois cette section terminée.',
      amount1: 'Montant du financement virtuel',
      amount2: 'Combien aimeriez-vous, si c\'était vraiment possible, dépenser par an pour vos espaces naturels préférés ? Il s\'agit d\'un montant fictif, mais essayez de choisir un chiffre qui vous semble réaliste.',
      amount3: 'Saisissez ci-dessous votre budget nature annuel (virtuel).',
      amount4: 'Pourriez-vous expliquer brièvement pourquoi vous avez choisi ce montant ? Par exemple, ce que vous trouvez important de soutenir, ou comment vous avez décidé de ce montant.',
      amount5: 'budget annuel',
      max: 'Montant maximum 5000 euros',
      min: 'Montant minimum 1 euro',
      locations1: 'Répartissez votre budget entre vos espaces naturels préférés',
      locations2: 'Indiquez comment vous répartiriez votre budget (virtuel) choisi entre les Fonds virtuels Nature et Communauté de vos espaces naturels préférés.',
      locations3: 'Pourriez-vous expliquer brièvement comment vous avez fait votre répartition ? Pourquoi avez-vous choisi de répartir ainsi ?',
      objectives1: 'Répartition du budget entre les objectifs de financement',
      objectives2: 'Vous voyez ici votre répartition entre les Fonds virtuels Nature et Communauté de votre zone. Vous pouvez le faire pour vos zones préférées dans votre quartier, votre région, votre pays et dans le monde. Indiquez comment vous répartiriez votre budget entre les quatre objectifs',
      objectives2a: 'Souhaitez-vous soutenir quelque chose qui n\'entre pas dans ces catégories ? Écrivez-le en bas sous « Autre, à savoir… » et attribuez-y une partie de votre budget.',
      objectives3: 'Pourriez-vous expliquer brièvement comment vous avez fait votre répartition ? Pourquoi avez-vous choisi de répartir ainsi ?',
      biodiversity_title: 'Conservation de la biodiversité',
      biodiversity_text: 'Une biodiversité riche soutient le fonctionnement des écosystèmes et est essentielle à toute vie sur terre. Les projets de conservation de la biodiversité visent à renforcer ou à préserver la biodiversité, souvent dans un contexte local. Ces projets peuvent viser à améliorer la qualité du sol et de l\'eau, ou par exemple à installer des nichoirs pour les oiseaux.',
      ALC_title: 'Qualité et vue du paysage',
      ALC_text: 'Le paysage concerne la vue et l\'agrément d\'un paysage. Un projet paysager peut porter sur la protection ou la restauration d\'éléments du paysage comme les haies, le réensauvagement du paysage ou la création de sentiers de randonnée ou de pistes cyclables à travers le paysage.',
      SUSBUS_title: 'Entrepreneuriat durable',
      SUSBUS_text: 'Les entreprises durables exercent leurs activités économiques sans effets négatifs sur leur environnement (local). Les projets d\'entreprise durable peuvent concerner la conversion d\'une exploitation conventionnelle vers une agriculture biologique ou respectueuse de la nature. Il peut aussi s\'agir de créer un réseau d\'entreprises et d\'organisations locales qui réduisent les déchets et la pollution de manière intégrée.',
      finalize1: '<b>Merci !</b><br> Merci d\'avoir participé à cette étude de l\'Université de Groningue sur le financement de la nature. Vos réponses sont précieuses. Cliquez sur <b>Enregistrer</b> pour enregistrer vos réponses.',
      finalize1A: '<b>Bravo !</b><br> Vous avez gagné 10 € pour des projets nature sur Texel. Merci, votre contribution nous aide à comprendre comment les gens veulent soutenir la nature.',
      finalize1B: '<b>Et ensuite ?</b><br> Vous allez maintenant rejoindre la communauté Greenmapper Friends « Parc national des Dunes de Texel » pour la partie 3. Vous y examinerez six vraies demandes de financement. Pour chaque projet, indiquez si vous le soutenez et pourquoi.\nVotre propre contribution dans cette expérience est fictive, mais les dons de 10 € et 5 € faits en votre nom sont réels.',
      finalize1C: '<b>Récompense supplémentaire pour Texel</b><br> Si vous répondez aux six demandes, Greenmapper fera un don supplémentaire de 5 €. Chaque réponse compte ! Après avoir répondu aux six demandes, vous participerez automatiquement au tirage au sort.',
      finalize2: 'Pour rappel, vous pouvez retirer les données que vous avez soumises sans aucune conséquence. Si vous le souhaitez, ou si vous avez d\'autres questions sur la recherche, envoyez un e-mail à',
      cultural_title: 'Culture et vie communautaire',
      cultural_text: 'Les espaces naturels peuvent aussi comporter un patrimoine culturel ou d\'autres aspects culturels, par exemple s\'ils contiennent des bâtiments ou monuments historiques ou si certains événements culturels y sont liés. Les projets culturels concernent l\'organisation d\'événements (musicaux), de sorties éducatives ou la préservation de domaines.',
      other_title: 'Autre',
      other_text: 'Souhaitez-vous financer autre chose dans votre espace naturel préféré, qui n\'est pas mentionné ci-dessus ? Nommez-le vous-même ! Vous pouvez utiliser ce curseur pour indiquer quelle part de votre budget vous y consacreriez. Ce n\'est pas obligatoire, seulement si vous pensez à quelque chose qui n\'appartient pas aux catégories d\'objectifs précédentes.',
      placeholder: 'Autre, à savoir..'
    }
  },
  drawer: {
    area_section: 'Découvrir',
    my_section: 'Mon aperçu',
    other_section: 'Autre',
    edit_funding: 'Mon budget nature',
    per_year: '/an',
    messages: 'Messages'
  },
  mail: {
    to: 'À',
    none: 'Pas encore de messages',
    from: 'De',
    subject: 'Titre',
    date: 'Date',
    inbox: 'Boîte de réception',
    outbox: 'Envoyés',
    compose: 'Nouveau message'
  },
  gender: {
    male: 'Homme',
    female: 'Femme',
    other: 'Autre'
  },
  education: {
    1: 'Moins que le lycée',
    2: 'Diplômé du lycée',
    3: 'Études supérieures, sans diplôme',
    4: 'Diplôme de premier cycle court (bac+2)',
    5: 'Licence',
    6: 'Master',
    7: 'Diplôme d\'école professionnelle',
    8: 'Doctorat'
  },
  video: {
    draw_popup_title_1: 'Quartier',
    draw_popup_subtitle_1: 'À 2 km de chez vous',
    draw_popup_text_1: 'Cette carte montre une zone de 2 km autour de votre domicile. Marquez un lieu lié à la nature, dans ces 2 km, qui est attrayant, précieux ou important pour vous. Si vous ne connaissez pas de lieu dans le cercle de 2 km, marquez une zone aussi proche que possible.',
    draw_popup_title_2: 'Région',
    draw_popup_subtitle_2: 'À 20 km de chez vous',
    draw_popup_text_2: 'Cette carte montre une zone de 20 km autour de votre domicile. Marquez un lieu lié à la nature, dans ces 20 km, qui est attrayant, précieux et important pour vous.',
    draw_popup_title_3: 'Pays',
    draw_popup_subtitle_3: 'Tout le pays',
    draw_popup_text_3: 'Cette carte montre les Pays-Bas. Marquez sur cette carte un lieu lié à la nature qui est attrayant, précieux ou important pour vous.',
    draw_popup_title_4: 'Monde',
    draw_popup_subtitle_4: 'Dans le monde',
    draw_popup_text_4: 'Cette carte montre le monde. Marquez sur cette carte un lieu lié à la nature qui est attrayant, précieux ou important pour vous.',
    draw_popup_video: 'Ci-dessous, une courte vidéo (30 s) montre comment dessiner une zone.',
    area_size: 'Zone : {width} km de large, {area} km{squared}',
    step1_helper: 'Déplacez la carte pour que votre lieu soit entièrement dans le cercle clair. Zoomez jusqu\'à ce que le cercle le couvre complètement.',
    step2_helper: 'Ça vous convient ? Continuez — ou faites glisser les points pour que la forme couvre mieux votre lieu.',
    clamp_hint_default: 'Cela reste dans un rayon de {distance}. La question suivante vous permet d\'aller plus loin.',
    scale_badge_radius: 'À {distance} de chez vous',
    scale_badge_full: 'Sur la carte de {name}',
    level_up_toast: 'Zone agrandie à {distance}'
  }
};